<template>
  <!--新品报验APQP-->
  <h-list-page class="NewProductInspectionApplication_style">
    <!-- 搜索条件 -->
    <h-card :title="h_i18n('13fe8d8c74cb94357d8e105686778dfe')" width="100%" footer is-search @change-method="changeMethod">
      <h-area>
        <!-- 样检单号 -->
        <h-search :title="h_i18n('1d2a691eda00b5b04a5911dfb42c2e22')">
          <h-input v-model="searchData.patternPlanId" clearable></h-input>
        </h-search>
        <!-- 专用号 -->
        <h-search :title="h_i18n('f1edca9f040d256cee01ef89fa5499f0')">
          <!-- 请输入至少四位专用号 -->
          <h-autocomplete
              popper-class="planHidden"
              v-model="searchData.mtlNo"
              :fetch-suggestions="mtlNoChange"
              :trigger-on-focus="false"
              @input="() =>searchData.mtlNo.length < 4? (plan.showMtlPlan = false): ''"
              @clear="plan.showMtlPlan = false"
              clearable
              :placeholder="h_i18n('3bdbd9312d3a6f04ebdb6b99ac0f2f4a')"
              @blur="myBlur('showMtlPlan')"
              @focus="myFocus3('showMtlPlan')"
          >
          </h-autocomplete>
          <h-detail width="400px" top="34px" left="0px">
            <el-table v-show="plan.showMtlPlan" v-loading="loading.mtlLoading" ref="filterTable" :data="mtlNoList" border size="small" max-height="252" @row-click="clickMtlNo" @mousedown="planBlur=true">
              <!-- 物料号 -->
              <el-table-column prop="mtlNo" :label="h_i18n('56ca9a2de6d54b00fb98ab39cce17089')" width="120"></el-table-column>
              <!-- 物料名称 -->
              <el-table-column prop="mtlName" :label="h_i18n('901fcadda8a5683e7a83a0c811ff4382')"></el-table-column>
            </el-table>
          </h-detail>
        </h-search>
        <!-- 物料描述 -->
        <h-search :title="h_i18n('aae11e21d2ef24d030976e023bc44ff5')">
          <h-input v-model="searchData.mtlName" clearable></h-input>
        </h-search>
        <!-- 工厂小微 -->
        <h-search :title="h_i18n('03490f3868798323211aa633194df2c1')">
          <!-- 请选择 -->
          <h-select v-model="searchData.sybId" :placeholder="h_i18n('708c9d6d2ad108ab2c560530810deae9')" style="width: 196px" clearable filterable>
            <h-option v-for="(item, index) in sybList" :key="index" :label="item.valueName" :value="item.valueId"></h-option>
          </h-select>
        </h-search>
        <!-- 物料大类 -->
        <h-search :title="h_i18n('33ac341a8748c430f721aa43dcf9f3b6')">
          <!-- 请选择 -->
          <h-select style="width: 100%" v-model="searchData.materielCategoryId" :placeholder="h_i18n('708c9d6d2ad108ab2c560530810deae9')" clearable filterable>
            <h-option
                v-for="item in materielCategoryNameList"
                :key="item.materielCategoryName"
                :label="item.materielCategoryName"
                :value="item.materielCategoryId"
            >
            </h-option>
          </h-select>
        </h-search>
        <!-- 检验方式 -->
        <h-search :title="h_i18n('6643ded0025cc29815fe4bd5ff7ae566')">
          <!-- 请选择 -->
          <h-select v-model="searchData.checkTypeId" :placeholder="h_i18n('708c9d6d2ad108ab2c560530810deae9')" clearable>
            <h-option v-for="item in inspectionMethod" :key="item" :label="item.label" :value="item.value"></h-option>
          </h-select>
        </h-search>
        <!-- 新品状态 -->
        <h-search :title="h_i18n('f3fc633edbae2e1c3841d6250db952c3')">
          <!-- 请选择 -->
          <h-select v-model="searchData.patternPlanStatus" multiple :placeholder="h_i18n('708c9d6d2ad108ab2c560530810deae9')" clearable class="myMultiple75">
            <h-option v-for="item in fileNewStatus" :key="item" :label="item.label" :value="item.value"></h-option>
          </h-select>
        </h-search>
        <!-- 物料状态 -->
        <h-search :title="h_i18n('e4e83fc681331d795f06a7099f9fa845')">
          <!-- 请选择 -->
          <h-select v-model="searchData.checkStatusId" multiple :placeholder="h_i18n('708c9d6d2ad108ab2c560530810deae9')" clearable class="myMultiple75">
            <h-option v-for="item in materialStatus" :key="item" :label="item.label" :value="item.value"></h-option>
          </h-select>
        </h-search>
        <!-- 文件状态 -->
        <h-search :title="h_i18n('a3d0154996e33be987462870be26d0da')">
          <!-- 请选择 -->
          <h-select v-model="searchData.selfCheckState" multiple :placeholder="h_i18n('708c9d6d2ad108ab2c560530810deae9')" style="width: 196px" clearable class="myMultiple75">
            <h-option v-for="item in fileStatus" :key="item" :label="item.label" :value="item.value"></h-option>
          </h-select>
        </h-search>
        <!-- 制版设计稿状态 -->
        <h-search :title="h_i18n('bc8fe2d1e2a6424c7a88234c68e32db1')">
          <!-- 请选择 -->
          <h-select v-model="searchData.pictureCheckState" multiple :placeholder="h_i18n('708c9d6d2ad108ab2c560530810deae9')" clearable class="myMultiple115">
            <h-option v-for="item in pictureStatus" :key="item" :label="item.label" :value="item.value"></h-option>
          </h-select>
        </h-search>
        <!-- 物料结论 -->
        <h-search :title="h_i18n('21aef4b20ab9d79ef20a4e8e56bda209')">
          <!-- 请选择 -->
          <h-select v-model="searchData.testConclusion" :placeholder="h_i18n('708c9d6d2ad108ab2c560530810deae9')" style="width: 196px" clearable>
            <!-- 合格 -->
            <h-option :key="1" :label="h_i18n('86f720320b77bb62311f0a4811db04fe')" value="P"></h-option>
            <!-- 不合格 -->
            <h-option :key="2" :label="h_i18n('6e5a122013138ad189517d5d0a1c0891')" value="F"></h-option>
          </h-select>
        </h-search>
        <!-- 文件结论 -->
        <h-search :title="h_i18n('24180f4b5aa44b93c2eb8e63a39b5607')">
          <!-- 请选择 -->
          <h-select v-model="searchData.documentConclusion" :placeholder="h_i18n('708c9d6d2ad108ab2c560530810deae9')" style="width: 196px" clearable>
            <!-- 合格 -->
            <h-option :key="1" :label="h_i18n('86f720320b77bb62311f0a4811db04fe')" value="P"></h-option>
            <!-- 不合格 -->
            <h-option :key="2" :label="h_i18n('6e5a122013138ad189517d5d0a1c0891')" value="F"></h-option>
          </h-select>
        </h-search>
        <!-- 最终结论 -->
        <h-search :title="h_i18n('915c2952f1f5e1d1d849eeca8b5d2b45')">
          <!-- 请选择 -->
          <h-select v-model="searchData.careerConclusionMark" :placeholder="h_i18n('708c9d6d2ad108ab2c560530810deae9')" style="width: 196px" clearable>
            <!-- 合格 -->
            <h-option :key="1" :label="h_i18n('86f720320b77bb62311f0a4811db04fe')" value="P"></h-option>
            <!-- 不合格 -->
            <h-option :key="2" :label="h_i18n('6e5a122013138ad189517d5d0a1c0891')" value="F"></h-option>
          </h-select>
        </h-search>
        <!-- 送样状态 -->
        <h-search :title="h_i18n('738f945f74701261355a9a9038aee82f')">
          <!-- 请选择 -->
          <h-select v-model="searchData.isSendFactoryTemp" :placeholder="h_i18n('708c9d6d2ad108ab2c560530810deae9')" style="width: 196px" clearable>
            <!-- 未送样 -->
            <h-option :key="1" :label="h_i18n('2f86334d978ce238df05ef655a71309d')" value="N"></h-option>
            <!-- 已送样 -->
            <h-option :key="2" :label="h_i18n('31c4e3275f4dbe2eb82ae02c7739736f')" value="Y"></h-option>
          </h-select>
        </h-search>
        
        <!-- 送样拖期原因 -->
        <h-search :title="h_i18n('01A3AD4C38FDCDB333EF79759E011F67')">
          <!-- 请选择 -->
          <h-select v-model="searchData.sendSampleDelayReason" multiple :placeholder="h_i18n('708c9d6d2ad108ab2c560530810deae9')" style="width: 196px" clearable class="myMultiple95">
            <h-option v-for="item in sendSampleDelayReasonData" :key="item" :label="item.label" :value="item.value"></h-option>
          </h-select>
        </h-search>
        <!-- 自检拖期原因 -->
        <h-search :title="h_i18n('001768F5D0D251C2E86828DBCE241DA7')">
          <!-- 请选择 -->
          <h-select v-model="searchData.selfDelayReason" multiple :placeholder="h_i18n('708c9d6d2ad108ab2c560530810deae9')" style="width: 196px" clearable class="myMultiple95">
            <h-option v-for="item in selfDelayReasonData" :key="item" :label="item.label" :value="item.value"></h-option>
          </h-select>
        </h-search>

        <!-- 计划生成日期 -->
        <h-search :title="h_i18n('7769321b9c543a0267ae4d19d82c4654')">
          <!-- 开始；结束 -->
          <h-date-picker clear-icon="el-icon-error" prefix-icon="iconfont icon-rili2" @change="dateMapChange('sendDay',dateMap.sendDay)" v-model="dateMap.sendDay" type="daterange" :start-placeholder="h_i18n('a3e3b88377c8a2f34e0f9ef6e67dbe62')" :end-placeholder="h_i18n('12f1d7ef38af6326c94fd11688f5b453')" clearable/>
        </h-search>
        <!-- 供方应送样日期 -->
        <h-search :title="h_i18n('1c9a150fc31786c2ecba42ca6ae00d7e')">
          <!-- 开始；结束 -->
          <h-date-picker clear-icon="el-icon-error" prefix-icon="iconfont icon-rili2" @change="dateMapChange('supplierSendFactorySamplePlanDate',dateMap.supplierSendFactorySamplePlanDate)" v-model="dateMap.supplierSendFactorySamplePlanDate" type="daterange" :start-placeholder="h_i18n('a3e3b88377c8a2f34e0f9ef6e67dbe62')" :end-placeholder="h_i18n('12f1d7ef38af6326c94fd11688f5b453')" clearable/>
        </h-search>
        <!-- 供方送样日期 -->
        <h-search :title="h_i18n('b297619e7b724d9e22738b73353f5c94')">
          <!-- 开始；结束 -->
          <h-date-picker clear-icon="el-icon-error" prefix-icon="iconfont icon-rili2" @change="dateMapChange('supplySendSampleDate',dateMap.supplySendSampleDate)" v-model="dateMap.supplySendSampleDate" type="daterange" :start-placeholder="h_i18n('a3e3b88377c8a2f34e0f9ef6e67dbe62')" :end-placeholder="h_i18n('12f1d7ef38af6326c94fd11688f5b453')" clearable/>
        </h-search>

        <template #operate>
          <h-button type="primary" :loading="loading.tableListLoading" @click="paginationQuery(1)">
            <template #icon>
              <search/>
            <!-- 查询 -->
            </template>{{ h_i18n('bee912d79eefb7335988c4997aa9138d') }}</h-button>
        </template>
      </h-area>
    </h-card>
    <div style="position: relative;margin-top: 10px;">
      <!-- 新品检验计划 -->
      <h-table-card :title="h_i18n('19fde6e4eac33cf5a9befed79c2309c8')" :is-left="2" :h-data="tableDataList" :is-right="1">
        <template #buttonGroup>
          <h-button-group>
            <!-- 查看 -->
            <h-button-select type="primary">{{ h_i18n('607e7a4f377fa66b0b28ce318aab841f') }}<template #icon>
                <preview-open theme="outline"/>
              </template>
              <template #list>
                <!-- 送样 -->
                <button-select-item @click="detailSampleBtn()" v-if="btnListOfSqm.some(item=>item.code == 'mkhl_xxpjyjh_SYCK')">{{ h_i18n('480314fec74c7ad31c65e15658d015fa') }}</button-select-item>
                <!-- 样检单 -->
                <button-select-item @click="detailPatternPlanBtn()" v-if="btnListOfSqm.some(item=>item.code == 'mkhl_xxpjyjh_YJD')">{{ h_i18n('9bc00dfcaffa57bf6a9b324b02e8a3b3') }}</button-select-item>
                <!-- 自检报告 -->
                <button-select-item @click="detailSelfInspectionBtn()" v-if="btnListOfSqm.some(item=>item.code == 'mkhl_xxpjyjh_ZJBG')">{{ h_i18n('497c8434bc60bc8e338faea5d44a6b6d') }}</button-select-item>
                <!-- 制版设计稿查看 -->
                <button-select-item v-if="templetFlag && btnListOfSqm.some(item=>item.code == 'mkhl_xxpjyjh_ZBSJG')" @click="detailPictureBtn()">{{ h_i18n('ef56762cdbe4eb9317ad296787abfb2a') }}</button-select-item>
                <!-- 检测报告 -->
                <button-select-item @click="detailTestReportBtn()" v-if="btnListOfSqm.some(item=>item.code == 'mkhl_xxpjyjh_JCBG')">{{ h_i18n('23ec39309965464235d52dc8d3769714') }}</button-select-item>
              </template>
            </h-button-select>
            <!-- <h-button-select type="primary">{{ h_i18n('2b6bc0f293f5ca01b006206c2535ccbc') }}<template #icon>
                <setting-two theme="outline"/>
              </template>
              <template #list> -->
                <!-- 送样 -->
                <h-button type="primary" @click="sendSampleBtn()" v-if="btnListOfSqm.some(item=>item.code == 'mkhl_xxpjyjh_SONGYANG')">{{ h_i18n('480314fec74c7ad31c65e15658d015fa') }}</h-button>
                <!-- 自检上传 -->
                <h-button type="primary" @click="upSelfInfpectionBtn()" v-if="btnListOfSqm.some(item=>item.code == 'mkhl_xxpjyjh_ZJSC')">{{ h_i18n('10a54b7cfc3ee0b8120adc93e8a76052') }}</h-button>
                <!-- 自检批准 -->
                <h-button type="primary" @click="auSelfInfpectionBtn()" v-if="btnListOfSqm.some(item=>item.code == 'mkhl_xxpjyjh_ZJPZ')">{{ h_i18n('145b2c31081ad6d14147640003961c6f') }}</h-button>
                <!-- 制版设计稿上传 -->
                <h-button type="primary" v-if="templetFlag && btnListOfSqm.some(item=>item.code == 'mkhl_xxpjyjh_ZBSJGSC')" @click="upPictureBtn()">{{ h_i18n('65d2b4cc69ee0d7fa8706a074b5b2b39') }}</h-button>
              <!-- </template> -->
              <!-- <template #list v-else>
                <button-select-item @click="lookDetail(multipleSelection[0])">查看</button-select-item>
              </template> --> 
            <!-- </h-button-select> -->

            <!-- 导出 -->
            <h-button type="default" @click="derive()" v-if="btnListOfSqm.some(item=>item.code == 'mkhl_xxpjyjh_DC')">{{ h_i18n('55405ea6ff6fd823ffab7e6b10ddfa95') }}<template #icon>
                <export/>
              </template>
            </h-button>
            <!-- 若样检单未查到，请至【新品检测（旧）】中进行处理。 -->
            <div style="display: flex;align-items: center;margin-left: 20px;color: #2164F5;font-size: 16px">{{ h_i18n('434A6D009D652CA9A0D1E3D241CD8565') }}</div>
          </h-button-group>
        </template>
        <!-- 请点击“查询”数据 -->
        <el-table :empty-text="h_i18n('8fd727180609a8164afad4b5eecc5544')" v-loading="loading.tableListLoading" height="540"
                  @selection-change="listCheckBoxChange" border :data="tableDataList" size="small"
                  style="width: 100%;min-height: 540px;">
          <el-table-column type="selection" width="40"></el-table-column>
          <!-- 样检单号 -->
          <el-table-column prop="patternPlanId" :label="h_i18n('1d2a691eda00b5b04a5911dfb42c2e22')" width="230"></el-table-column>
          <!-- 计划生成日期 -->
          <el-table-column prop="sendDay" :label="h_i18n('7769321b9c543a0267ae4d19d82c4654')" min-width="100" :formatter="({sendDay})=>formDate(sendDay,3)"></el-table-column>
          <!-- 专用号 -->
          <el-table-column prop="mtlNo" :label="h_i18n('f1edca9f040d256cee01ef89fa5499f0')" width="150"></el-table-column>
          <!-- 物料名称 -->
          <el-table-column prop="mtlName" :label="h_i18n('901fcadda8a5683e7a83a0c811ff4382')" width="170"></el-table-column>
          <!-- 物料大类 -->
          <el-table-column prop="materielCategoryId" :label="h_i18n('33ac341a8748c430f721aa43dcf9f3b6')" width="100" :formatter="({materielCategoryId})=>materielCategoryFormatter(materielCategoryId)"></el-table-column>
          <!-- 自检类别 -->
          <el-table-column prop="materialLevel" :label="h_i18n('31342bc2f6f90b324f6a4aaee4208c12')" min-width="80"></el-table-column>
          <!-- 工厂小微 -->
          <el-table-column prop="sybName" :label="h_i18n('03490f3868798323211aa633194df2c1')" min-width="130"></el-table-column>
          <!-- 检验方式 -->
          <el-table-column prop="mtlGroup" :label="h_i18n('6643ded0025cc29815fe4bd5ff7ae566')" min-width="80">
            <template #default="{row}">
              <div v-html="inspectionMethodRender(row.checkTypeId)"></div>
            </template>
          </el-table-column>
          <!-- 新品状态 -->
          <el-table-column prop="patternPlanStatus" :label="h_i18n('f3fc633edbae2e1c3841d6250db952c3')" min-width="120">
            <template #default="{row}">
              {{ patternPlanStatusRender(row) }}
            </template>
          </el-table-column>
          <!-- 物料状态 -->
          <el-table-column prop="checkStatusId" :label="h_i18n('e4e83fc681331d795f06a7099f9fa845')" min-width="140">
            <template #header>
              <div class="tip_box flexEnd">
                <!-- 物料状态 -->
                <span class="title">{{ h_i18n('e4e83fc681331d795f06a7099f9fa845') }}</span>
                <el-tooltip class="box-item" effect="dark" placement="top">
                  <template #content>
                      1. 状态为【—】：无需操作
                      <br />
                      2. 待送工厂样：操作人：供应商质量经理；操作系统：SQM（sqm.haier.net）
                      <br />
                      3. 待外检收样：操作人：外检经理；操作系统：智慧检验
                      <br />
                      4. 收样驳回：操作人：供应商质量经理；操作系统：SQM（sqm.haier.net）
                      <br />
                      5. 待检验：操作人：外检经理；操作系统：智慧检验
                      <br />
                      6. 检验待校核：操作人：外检负责人；操作系统：智慧检验
                      <br />
                      7. 物料校核驳回：操作人：外检经理；操作系统：智慧检验
                      <br />
                      8. 物料检验合格：物料检验单项流程结束
                      <br />
                      9. 物料检验不合格：物料检验单项流程结束
                  </template>
                  <span class="tip_icon_box"><info /></span>
                </el-tooltip>
              </div>
            </template>
            <template #default="{row}">
              <div class="blueColor" v-if="row.checkStatusId===2219">{{ materialStatus.find(item=>item.value == row.checkStatusId).label }}</div>
              <div class="successColor" v-else-if="row.checkStatusId===2220">{{ materialStatus.find(item=>item.value == row.checkStatusId).label }}</div>
              <div class="dangerColor" v-else-if="row.checkStatusId===2221">{{ materialStatus.find(item=>item.value == row.checkStatusId).label }}</div>
              <div class="blueColor" v-else-if="row.checkStatusId===2222">{{ materialStatus.find(item=>item.value == row.checkStatusId).label }}</div>
              <div class="blueColor" v-else-if="row.checkStatusId===2223">{{ materialStatus.find(item=>item.value == row.checkStatusId).label }}</div>
              <div class="successColor" v-else-if="row.checkStatusId===2224">{{ materialStatus.find(item=>item.value == row.checkStatusId).label }}</div>
              <div class="dangerColor" v-else-if="row.checkStatusId===2237">{{ materialStatus.find(item=>item.value == row.checkStatusId).label }}</div>
              <div class="dangerColor" v-else-if="row.checkStatusId===2502">{{ materialStatus.find(item=>item.value == row.checkStatusId).label }}</div>
              <div v-else>-</div>
            </template>
          </el-table-column>
          <!-- 文件状态 -->
          <el-table-column prop="selfCheckState" :label="h_i18n('a3d0154996e33be987462870be26d0da')" min-width="100">
            <template #header>
              <div class="tip_box flexEnd">
                <!-- 文件状态 -->
                <span class="title">{{ h_i18n('a3d0154996e33be987462870be26d0da') }}</span>
                <el-tooltip class="box-item" effect="dark" placement="top">
                  <template #content>
                      1. 状态为【—】：无需操作
                      <br />
                      2. 自检待上传-供方：操作人：供应商质量经理；操作系统：SQM（sqm.haier.net）
                      <br />
                      3. 自检待审核：操作人：外检经理；操作系统：智慧检验
                      <br />
                      4. 自检审核驳回：操作人：供应商质量经理；操作系统：SQM（sqm.haier.net）
                      <br />
                      5. 自检待校核：操作人：外检负责人；操作系统：智慧检验
                      <br />
                      6. 借用模板合格：供应商存在有效期内合格模板
                      <br />
                      7. 自检待批准-供方：操作人：供应商质量部长；操作系统：SQM（sqm.haier.net）
                      <br />
                      8. 自检批准驳回-供方：操作人：供应商质量经理；操作系统：SQM（sqm.haier.net）
                      <br />
                      9. 自检校核驳回：操作人：外检经理；操作系统：智慧检验
                      <br />
                      10. 自检合格：文件单项流程结束
                      <br />
                      11. 自检不合格：文件单项流程结束
                  </template>
                  <span class="tip_icon_box"><info /></span>
                </el-tooltip>
              </div>
            </template>
            <template #default="{row}">
              <div class="blueColor" v-if="row.selfCheckState===2226">{{ fileStatus.find(item=>item.value == row.selfCheckState).label }}</div>
              <div class="warningColor plan_a_a" v-else-if="row.selfCheckState===2227">{{ fileStatus.find(item=>item.value == row.selfCheckState).label }}</div>
              <div class="warningColor plan_a_a" v-else-if="row.selfCheckState===2229">{{ fileStatus.find(item=>item.value == row.selfCheckState).label }}</div>
              <div class="dangerColor" v-else-if="row.selfCheckState===2228">{{ fileStatus.find(item=>item.value == row.selfCheckState).label }}</div>
              <div class="dangerColor" v-else-if="row.selfCheckState===2236">{{ fileStatus.find(item=>item.value == row.selfCheckState).label }}</div>
              <div class="dangerColor" v-else-if="row.selfCheckState===2501">{{ fileStatus.find(item=>item.value == row.selfCheckState).label }}</div>
              <div class="successColor" v-else-if="row.selfCheckState===2230">{{ fileStatus.find(item=>item.value == row.selfCheckState).label }}</div>
              <div v-else-if="row.selfCheckState === 2248">{{ fileStatus.find(item=>item.value == row.selfCheckState).label }}</div>
              <div v-else-if="row.selfCheckState === 2249">{{ fileStatus.find(item=>item.value == row.selfCheckState).label }}</div>
              <div class="successColor" v-else-if="row.selfCheckState === 2247">{{ fileStatus.find(item=>item.value == row.selfCheckState).label }}</div>
              <div v-else>-</div>
            </template>
          </el-table-column>
          <!-- 制版设计稿状态 -->
          <el-table-column prop="pictureCheckState" :label="h_i18n('bc8fe2d1e2a6424c7a88234c68e32db1')" width="150" :formatter="({pictureCheckState})=>fileCheckPictureStatus(pictureCheckState)">
            <template #header>
              <div class="tip_box flexEnd">
                <!-- 制版设计稿状态 -->
                <span class="title">{{ h_i18n('bc8fe2d1e2a6424c7a88234c68e32db1') }}</span>
                <el-tooltip class="box-item" effect="dark" placement="top">
                  <template #content>
                    1. 状态为【—】：无需操作
                      <br />
                      2. 待上传：操作人：供应商质量经理；操作系统：SQM（sqm.haier.net）
                      <br />
                      3. 待审核：操作人：型号经理；操作系统：智慧检验
                      <br />
                      4. 审核打回：操作人：供应商质量经理；操作系统：SQM（sqm.haier.net）
                      <br />
                      5. 审核合格：制版设计稿单项流程结束
                      <br />
                      6. 审核不合格：制版设计稿单项流程结束
                  </template>
                  <span class="tip_icon_box"><info /></span>
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
          <!-- <el-table-column label="研发状态" min-width="110">
            <template #default="{row}">
              <div v-if="row.devStatus===2231">待供方送研发样</div>
              <div class="successColor" v-if="row.devStatus===2232">待研发确认</div>
              <div class="dangerColor" v-if="row.devStatus===2242">研发驳回</div>
              <div class="dangerColor" v-if="row.devStatus===2243">研发已确认</div>
              <div v-else></div>
            </template>
          </el-table-column> -->
          <!-- 应送样日期 -->
          <el-table-column prop="supplierSendFactorySamplePlanDate" :label="h_i18n('dd3a693650e8cd18af7acf4fef901bb8')" min-width="120" :formatter="({supplierSendFactorySamplePlanDate})=>formDate(supplierSendFactorySamplePlanDate,3)"></el-table-column>
          <!-- 实际送样日期 -->
          <el-table-column prop="supplySendSampleDate" :label="h_i18n('70c23f9ec38abbfda9cdb4ead0829a2d')" min-width="120" :formatter="({supplySendSampleDate})=>formDate(supplySendSampleDate,3)"></el-table-column>
          <!-- 送样拖期原因 -->
          <el-table-column prop="sendSampleDelayReasonName" :label="h_i18n('01A3AD4C38FDCDB333EF79759E011F67')" min-width="120">
          </el-table-column>
          <!-- 外检收样日期 -->
          <el-table-column prop="sqeAffirmDate" :label="h_i18n('8b8586eac6d0080f4ca5c6d82f0b9fba')" width="120" 
            :formatter="({sqeAffirmDate})=>formDate(sqeAffirmDate,3)">
          </el-table-column>
          <!-- 外检收样打回；次数；次 -->
          <el-table-column prop="iqcReceiveSampleBackCount" :label="h_i18n('9ec6d1e0c2004c5f49888ad7dcb7458d') + h_i18n('f965fea30858da6b154464a16271116d') + '('+ h_i18n('7229ecc63125adf7fcf2867d792a77be') +')'" width="180">
            <template #default="{ row }">
              {{ row.iqcReceiveSampleBackCount || '-'}}
            </template>
          </el-table-column>
          <!-- 应自检完成日期 -->
          <el-table-column prop="supplierSelfCheckPlanDate" :label="h_i18n('733b8117d62ea1566ed893e9d0aaac2b')" min-width="120" :formatter="({supplierSelfCheckPlanDate})=>formDate(supplierSelfCheckPlanDate,3)"></el-table-column>
          <!-- 自检拖期原因 -->
          <el-table-column prop="selfDelayReasonName" :label="h_i18n('001768F5D0D251C2E86828DBCE241DA7')" min-width="120">
          </el-table-column>
          <!-- 实自检完成日期 -->
          <el-table-column prop="supplyCheckDate" :label="h_i18n('793d7e923db847db90796b85c94eac20')" min-width="120" :formatter="({supplyCheckDate})=>formDate(supplyCheckDate,3)"></el-table-column>
          <!-- <el-table-column prop="aa" label="应送研发样日期" min-width="170"></el-table-column> -->
          <!-- <el-table-column prop="aa" label="实送研发样日期" min-width="170"></el-table-column> -->
          <!-- <el-table-column prop="devStatus" label="送研发样" min-width="115">
            <template #default="{row}">
              <div class="h-global-font--blue" v-if="row.devStatus===2231">待供方送研发样</div>
              <div class="successColor plan_a_a" v-else-if="row.devStatus===2232">待研发确认</div>
              <div class="dangerColor" v-else-if="row.devStatus===2242">研发驳回</div>
              <div class="dangerColor" v-else-if="row.devStatus===2243">研发已确认</div>
              <div v-else>-</div>
            </template>
          </el-table-column> -->
          <!-- 送工厂样 -->
          <el-table-column prop="checkStatusId" :label="h_i18n('fdeccb03565bc84a3d4225e42063c32f')" min-width="95">
            <template #default="{row}">
              <!-- 待送工厂样 -->
              <div class="h-global-font--blue" v-if="row.checkStatusId===2219" @click="checkStatusM(row)">{{ h_i18n('6cde0390f53aa56bfbc28a6576a41055') }}</div>
              <!-- 送样驳回 -->
              <div class="dangerColor pointer" v-else-if="row.checkStatusId===2221" @click="checkStatusM(row)">{{ h_i18n('c580a25a1afd0be7b6c80a6d310e0690') }}</div>
              <div v-else-if="!row.checkStatusId">-</div>
              <!-- v-if="row.checkStatusId===2220" -->
              <!-- 已送样 -->
              <div class="successColor pointer" v-else @click="checkStatusM(row)">{{ h_i18n('31c4e3275f4dbe2eb82ae02c7739736f') }}</div>
            </template>
          </el-table-column>
          <!-- 制版设计稿实上传 -->
          <el-table-column prop="pictureFileTime" :label="h_i18n('a422d41b065897069e72f1d2560fbe67')" min-width="170" :formatter="({pictureFileTime})=>formDate(pictureFileTime,6)"></el-table-column>

          <!-- <el-table-column prop="selfCheckState" label="文件状态" min-width="105">
            <template #default="{row}">
              <div class="h-global-font--blue" v-if="row.selfCheckState===2226" @click="upload('upload',row)">自检待上传</div>
              <div class="warningColor plan_a_a" v-if="row.selfCheckState===2227">自检待审核</div>
              <div class="warningColor plan_a_a" v-if="row.selfCheckState===2229">自检待校核</div>
              <div class="dangerColor pointer" v-if="row.selfCheckState===2228" @click="upload('repulse',row)">自检审核驳回</div>
              <div class="dangerColor" v-if="row.selfCheckState===2236" @click="lookDetail(row)">自检不合格</div>
              <div class="successColor pointer" v-if="row.selfCheckState===2230" @click="lookDetail(row)">自检合格</div>
              <div class="h-global-font--blue pointer" v-if="row.selfCheckState === 2248" @click="upload('upload-b',row)">自检待批准</div>
              <div class="dangerColor pointer" v-if="row.selfCheckState === 2249" @click="upload('repulse-b',row)">自检批准驳回</div>
              <div v-else></div>
            </template>
          </el-table-column> -->
          <!-- <el-table-column label="日志" min-width="50">
            <template #default="{row}">
              <div class="h-global-font--blue" @click="lookLog(row)">查看</div>
            </template>
          </el-table-column> -->
          <!-- 流程 -->
          <el-table-column prop="checkStatusId" :label="h_i18n('f630b9a4da10f81b7bb1c75bf6345558')" min-width="50">
            <template #default="{ row }">
              <!-- 查看 -->
              <div class="h-global-font--blue" @click="flowPlan(row)">{{ h_i18n('607e7a4f377fa66b0b28ce318aab841f') }}</div>
            </template>
          </el-table-column>
        </el-table>
        <template #pagination>
          <el-pagination background @current-change="paginationQuery" v-model:currentPage="pageNation.pageIndex"
                         :page-size="10" layout="total, prev, pager, next,jumper" :total="pageNation.total">
          </el-pagination>
        </template>
      </h-table-card>
    </div>
    <!--上传-->
    <h-dialog :show="fileUploadM" :title="h_i18n('481e034e6026969aae4ce7ce7c8a7b6f')" footer @close="fileUploadM=false" width="540px">
      <h-upload @file-change="chooseFile" :max="30" :max-length="10" @error="errorFile" :file-list="fileList" h-accept="png,jpg,jpeg,PNG,JPG,JPEG" style="padding:20px;">
        <template #tips>
          <div>{{ h_i18n('f6dd1cd8f40e43fcfb8c34fca40a7777') }}</div>
        </template>
      </h-upload>
      <template #footer>
        <h-button-group align="right">
          <h-button type="primary" @click="uploadFile">{{ h_i18n('e83a256e4f5bb4ff8b3d804b5473217a') }}</h-button>
        </h-button-group>
      </template>
    </h-dialog>
    <!--图片查看-->
    <!-- 文件上传 -->
    <h-dialog :show="pictureL" :title="h_i18n('481e034e6026969aae4ce7ce7c8a7b6f')" @close="pictureL=false" width="1000px">
      <div class="picture-list">
        <img class="picture-list-item" v-for="item in pictureList" :src="$filePathSplicing(item, 'img')" :alt="item" @click="openImg(item)"/>
      </div>
    </h-dialog>
    <!--抽屉查看日志-->
    <el-drawer v-model="drawerLog" :show-close="false" size="800px">
      <template #title>
        <!-- 查看日志 -->
        <div class="titleDrawer">{{ h_i18n('0ea78e42790049d9f9397826c8c07718') }}</div>
        <h-button style="margin-left: 10px" type="default" @click="drawerLog=false">
          <template #icon>
            <close theme="outline"/>
          <!-- 关闭 -->
          </template>{{ h_i18n('b15d91274e9fc68608c609999e0413fa') }}</h-button>
      </template>
      <template #default>
        <div style="height: 100%;padding:4px 24px;">
          <!-- 请点击“查询”数据 -->
          <el-table :empty-text="h_i18n('8fd727180609a8164afad4b5eecc5544')" v-loading="logLoading" height="100%" border :data="logList" size="small" style="border-radius: 8px;border-collapse: collapse;">
            <!-- 操作人 -->
            <el-table-column prop="checkMan" :label="h_i18n('f9ac4b2aa6b51d9578551cd06316d81a')" width="90"></el-table-column>
            <!-- 操作方 -->
            <el-table-column prop="checkRole" :label="h_i18n('c8b3a9beb5a20cfe42ef990b80b0eb4f')" width="80"></el-table-column>
            <!-- 结论 -->
            <el-table-column prop="conclusion" :label="h_i18n('54bbba803f13eaab0f5441d97b13247a')" width="60" :formatter="({conclusion,checkRole})=>conclusionMethod(conclusion,checkRole)"></el-table-column>
            <!-- 操作日期 -->
            <el-table-column prop="checkDate" :label="h_i18n('ce6f9d37666ec725365acdf682b3f125')" width="170" :formatter="({checkDate})=>formDate(checkDate,6)"></el-table-column>
            <!-- 备注 -->
            <el-table-column prop="checkReason" :label="h_i18n('2432b57515b3627faddccb1dd1df206e')" min-width="170"></el-table-column>
          </el-table>
        </div>
      </template>
    </el-drawer>
    <!--抽屉供应商送样-->
    <el-drawer v-model="drawer" :show-close="false" size="560px" @close="drawer=false , clearsendSampleDelayReason()">
      <template #title>
        <!-- 供应商送样 -->
        <div class="titleDrawer">{{ h_i18n('cde14d8fb1c3b27a5fc67c030f98b646') }}</div>
        <h-button type="primary" @click="sampleLog(sampleDelivery.patternPlanId)">
          <history theme="outline" />
          <!-- 送样历史 -->
          {{ h_i18n('480314fec74c7ad31c65e15658d015fa') + h_i18n('c827d8dbb76ce33219f64c6749893159') }}
        </h-button>
        <h-button style="margin-left: 10px" type="primary" @click="sampleDeliverySubmit" :loading="sampleDeliveryLoading" v-if="status!==2">
          <template #icon>
            <send theme="outline"/>
          <!-- 送样 -->
          </template>{{ h_i18n('480314fec74c7ad31c65e15658d015fa') }}</h-button>
        <h-button style="margin-left: 10px" type="warning" @click="drawer=false , clearsendSampleDelayReason()">
          <template #icon>
            <close theme="outline"/>
          <!-- 关闭 -->
          </template>{{ h_i18n('b15d91274e9fc68608c609999e0413fa') }}</h-button>
      </template>
      <template #default>
        <div class="default_box_style">
          <el-row>
            <el-col>
               <!-- 供方计划送样时间 input-->
               <div class="default_title_style">{{ h_i18n('8e20b70327602db813a03df90b7a9ed8') }}</div>
               <el-input class="default_input_style" v-model="sampleDelivery.supplierSendFactorySamplePlanDate" :disabled="true"/>
            </el-col>
          </el-row>
          <el-row>
            <el-col>
               <!-- 供方送样人 input-->
               <div class="default_title_style">{{ h_i18n('6a52ae8d38d65d94a9673129041ca156') }}</div>
               <!-- 请填写供方送样人 -->
               <el-input class="default_input_style" v-model="sampleDelivery.supplySendSampleMan" :placeholder="h_i18n('67c83d436e9086e71a2d1440d1c4cac8')" :disabled="status===2"/>
            </el-col>
          </el-row>
          <!-- 供方送样数量 -->
          <el-row>
            <el-col>
              <!-- 供方送样数量 -->
              <div class="default_title_style">{{ h_i18n('0a5b1df588a1e061097183d52c2d585b') }}</div>
              <el-input-number v-model="sampleDelivery.supplySendSampleNumber" :disabled="status===2" :min="1" max="Infinity"/>
              <!-- 注：送样数量请确保真实准确 -->
              <div class="default_input_style default-body-text">{{ h_i18n('e56a3f881fb48d3f68ae7cbf578ac285') }}</div>
            </el-col>
          </el-row>
          <el-row>
            <el-col>
              <!-- 送样方式 -->
              <div class="default_title_style">{{ h_i18n('195fe52c72f3f8c6be34c497b47c94bc') }}</div>
              <el-radio-group class="default_input_style" v-model="sampleDelivery.deliveryType" :disabled="status===2" @change="deliveryTypeChange(sampleDelivery.deliveryType)">
                  <!-- 快递 -->
                  <el-radio :label="h_i18n('705d54db81f6eaf23b9c56eb0b4b40d4')">{{ h_i18n('705d54db81f6eaf23b9c56eb0b4b40d4') }}</el-radio>
                  <!-- 自送 -->
                  <el-radio :label="h_i18n('98789c2803dd7db3c272916eb1a2afae')">{{ h_i18n('98789c2803dd7db3c272916eb1a2afae') }}</el-radio>
              </el-radio-group>
            </el-col>
          </el-row>
          <!-- 填写快递单号 -->
          <el-row>
            <el-col>
              <!-- 填写快递单号 -->
              <div class="default_title_style">{{ h_i18n('ccfd94405616cab3f474c47930246646') }}</div>
              <!-- 请填写快递单号；自送 -->
              <el-input class="default_input_style" v-model="sampleDelivery.deliveryNo" :placeholder="h_i18n('416ddc927e1406f5e80ae9bac4b50727')" :disabled="sampleDelivery.deliveryType===h_i18n('98789c2803dd7db3c272916eb1a2afae')||status===2"/>
            </el-col>
          </el-row>
          <el-row>
            <el-col>
              <!-- 预计送样时间 -->
              <div class="default_title_style">{{ h_i18n('5ad67a9e2faec80e40f03e924c59dc43') }}</div>
              <el-date-picker class="default_input_style date_input_style" style="width:100% !important" v-model="sampleDelivery.planDeliveryDate" :disabled-date="disabledDate" type="date" :disabled="status===2" @change="planDeliveryDateTime(sampleDelivery)"/>
            </el-col>
          </el-row>
          <el-row>
            <el-col>
              <!-- 送样样件照片 -->
              <div class="default_title_style" style="color:#4E5969">{{ h_i18n('1bde84c9de69d3fb8ad01e70a14455df') }}</div>
              <div class="default-body-item" v-if="status!==2">
                <h-button type="primary" @click="openPlan" :disabled="status===2">
                  <template #icon>
                    <pic theme="outline"/>
                  <!-- 选择照片 -->
                  </template>{{ h_i18n('c2e40619f0ce7fd31e3ac102ead76a6b') }}</h-button>
                <div class="default-body-picture">
                  <!-- 支持上传格式：.jpg.jpeg.png，最少上传2张。单个文件不大于30M。 -->
                  <div class="default-body-text">{{ h_i18n('711ed4f497816c2d1219e8f76d1fa76e') }}</div>
                  <!-- <div class="default-body-text">2.单个文件不大于30M</div> -->
                </div>
              </div>
              <div class="default-body-image-list">
                <div class="default-body-image" v-for="item in fileListOld" @click="lookPicture" :key="item">
                  <img class="default-body-image-icon" :src="$filePathSplicing(item.filePath, 'img')" :alt="item.fileName"/>
                  <!-- <div class="default-body-image-name">{{ item.fileName }}</div> -->
                </div>
              </div>          
            </el-col>
          </el-row>
          <el-row v-if="sendSampleDelayReasonShow">
            <!-- 送样拖期原因 -->
            <div class="default_title_style">{{ h_i18n('01A3AD4C38FDCDB333EF79759E011F67') }}</div>
            <el-select class="default_input_style" v-model="sampleDelivery.sendSampleDelayReason" placeholder="请选择" style="width: 100%;"
              @change="sendSampleDelayReasonChoose()" filterable :disabled="status === 2">
              <el-option v-for="item in sendSampleDelayReasonData" :value="item.value" :key="item.value" :label="item.label"></el-option>
            </el-select>
          </el-row>
          <el-row v-if="sendSampleDelayReasonRemarkShow">
            <!-- 送样拖期其它原因说明 -->
            <div class="default_title_style">{{ h_i18n('D5D682769E2FD411333DB100B9A6AD3E') }}</div>
            <el-input class="default_input_style" v-model="sampleDelivery.sendSampleDelayReasonRemark" show-word-limit maxlength="200" :rows="3" type="textarea"
            :disabled="status === 2" placeholder="请输入"></el-input>
          </el-row>
          <el-row v-if="status!==1">
            <el-col>
              <!-- 检验收样时间 -->
              <div class="default_title_style">{{ h_i18n('296b2d40f689d423ab3dd66889c76fde') }}</div>
              <el-input v-if="status!==1" class="default_input_style" v-model="sampleDelivery.sqeAffirmDate" :disabled="true"/>
              <!-- <el-date-picker v-else class="default_input_style" v-model="sampleDelivery.sqeAffirmDate" type="date" :disabled="status===2" @change="planDeliveryDateTime(sampleDelivery)"/> -->
            </el-col>
          </el-row>
          <el-row v-if="status!==1">
            <el-col>
              <!-- 收样意见 -->
              <div class="default_title_style" style="color:#4E5969;font-size: 16px;">{{ h_i18n('b9bca46ff88c72b2d00059ff9b2ed396') }}</div>
              <el-input v-if="status!==1" class="default_input_style" disabled :rows="3" type="textarea" v-model="sampleDelivery.sqeAffirmMark"></el-input>
            </el-col>
          </el-row>
        </div>
        <!-- <div class="default-box" style="overflow-y: auto;height: calc(100vh - 60px);">
          <div class="default-body">
            <div class="default-body-left">
              <div class="default-body-item">供方计划送样时间</div>
              <div class="default-body-item">供方送样人</div>
              <div class="default-body-item">供方送样数量</div>
              <div class="default-body-text"></div>
              <div class="default-body-item">送样方式</div>
              <div class="default-body-item">填写快递单号</div>
              <div class="default-body-item">预计送样时间</div>
              <div class="default-body-item" v-if="status!==2">送样样件照片</div>
              <div class="default-body-title" v-if="status!==1">送样样件照片</div>
              <div class="default-body-item" v-if="status!==1">检验收样时间</div>
              <div class="default-body-item" v-if="status!==1">收样意见</div>
            </div>
            <div class="default-body-right">
              <div class="default-body-item">
                <el-input v-model="sampleDelivery.supplierSendFactorySamplePlanDate" :disabled="true"/>
              </div>
              <div class="default-body-item">
                <el-input v-model="sampleDelivery.supplySendSampleMan" placeholder="请填写供方送样人" :disabled="status===2"/>
              </div>
              <div class="default-body-item">
                <el-input-number v-model="sampleDelivery.supplySendSampleNumber" :disabled="status===2" :min="1" max="Infinity"/>
              </div>
              <div class="default-body-text">注：送样数量请确保真实准确</div>
              <div class="default-body-item">
                <el-radio-group v-model="sampleDelivery.deliveryType" :disabled="status===2" @change="deliveryTypeChange(sampleDelivery.deliveryType)">
                  <el-radio label="快递">快递</el-radio>
                  <el-radio label="自送">自送</el-radio>
                </el-radio-group>
              </div>
              <div class="default-body-item">
                <el-input v-model="sampleDelivery.deliveryNo" placeholder="请填写快递单号" :disabled="sampleDelivery.deliveryType==='自送'||status===2"/>
              </div>
              <div class="default-body-item">
                <el-date-picker v-model="sampleDelivery.planDeliveryDate" type="date" :disabled="status===2" @change="planDeliveryDateTime(sampleDelivery)"/>
              </div>
              <div class="default-body-item" v-if="status!==2">
                <h-button type="primary" @click="openPlan" :disabled="status===2">
                  <template #icon>
                    <pic theme="outline"/>
                  </template>
                  选择照片
                </h-button>
                <div class="default-body-picture">
                  <div class="default-body-text">1.至少上传2张照片，照片类型：jpeg、png、jpg</div>
                  <div class="default-body-text">2.单个文件不大于30M</div>
                </div>
              </div>
              <div class="default-body-image-list">
                <div class="default-body-image" v-for="item in fileListOld" @click="lookPicture">
                  <img class="default-body-image-icon" :src="item.filePath" :alt="item.fileName">
                  <div class="default-body-image-name">{{ item.fileName }}</div>
                </div>
              </div>

              <div class="default-body-item" v-if="status!==1" style="margin-bottom:18px;">
                <el-input v-model="sampleDelivery.sqeAffirmDate" :disabled="true"/>
              </div>
              <div class="default-body-textarea" v-if="status!==1">
                <el-input disabled :rows="3" type="textarea" v-model="sampleDelivery.sqeAffirmMark"></el-input>
              </div>
            </div>
          </div>
        </div> -->
      </template>
    </el-drawer>

    <!--流程-->
    <el-drawer v-model="flow" direction="ttb" :show-close="false" @opened="flowOpened" :before-close="closeFlow" :size="flow_content">
      <template #title>
        <!-- 新品流程 -->
        <div class="titleDrawer">{{ h_i18n('46e8da056bdca777d47d3743d4b229e0') }}</div>
        <h-button style="margin-left: 10px" type="warning" @click="closeFlow">
          <template #icon>
            <close theme="outline"/>
          <!-- 关闭 -->
          </template>{{ h_i18n('b15d91274e9fc68608c609999e0413fa') }}</h-button>
      </template>
      <div class="flow-left"> 
        <div>
          <!-- 样检单号 -->
          {{ h_i18n('1d2a691eda00b5b04a5911dfb42c2e22') }} : {{ rowData.patternPlanId }}
        </div> 
        <div>
          <!-- 专用号 -->
          {{ h_i18n('f1edca9f040d256cee01ef89fa5499f0')  }} : {{ rowData.mtlNo }} 
        </div>
        <div>
          <!-- 物料描述 -->
          {{ h_i18n('aae11e21d2ef24d030976e023bc44ff5') }} : {{ rowData.mtlName }}
        </div>
        <div>
          <!-- 供应商代码 -->
          {{ h_i18n('1b7ecd2bdbd8a1a112dead57724f06df')  }} : {{ rowData.supplyCode }}
        </div>
        <div>
          <!-- 供应商名称 -->
          {{ h_i18n('9190cc22c9ba377113bc54ac51013a0b') }} : {{ rowData.supplyName }}
        </div>
        <div>
          <!-- 工厂小微 -->
          {{ h_i18n('03490f3868798323211aa633194df2c1') }} : {{ rowData.sybId }} - {{ rowData.sybName }}
        </div>
      </div>
      <div class="flow-body" id="flowContent"></div>
      <el-drawer v-model="flow_insert" direction="ttb" :show-close="false" @opened="flowOpened" :size="300" @closed="flow_content=650">
        <template #title>
          <!-- 实验流程追踪 -->
          <div class="titleDrawer">{{ h_i18n('0f6634460c8378eb46405d6afad4c330') }}</div>
          <h-button style="margin-left: 10px" type="warning" @click="flow_insert=false">
            <template #icon>
              <close theme="outline"/>
            <!-- 关闭 -->
            </template>{{ h_i18n('b15d91274e9fc68608c609999e0413fa') }}</h-button>
        </template>
        <div class="flow">
          <div class="flow-item" v-for="ii in testList" :key="ii">
            <div class="flow-item-title">{{ ii.orderCode }}</div>
            <div class="flow-item-content">
              <div class="flow-item-content-body">
                <div class="flow-item-content-body-item" :class="ii.orderEntrustTime ? 'blueBackColor' : 'grayBackColor'">
                  <!-- 外检实验订单下达 -->
                  <div class="flow-item-header">{{ h_i18n('b66a5a5214f34e1e4c042a817d20402f') }}</div>
                  <div class="flow-item-time">
                    {{ ii.orderEntrustTime }}
                  </div>
                </div>
                <div class="flow-item-content-body-item" :class="ii.orderReceiveTime ? 'blueBackColor' : 'grayBackColor'">
                  <!-- 实验室派单 -->
                  <div class="flow-item-header">{{ h_i18n('381a4e1e66828f7b451be3926311aefe') }}</div>
                  <div class="flow-item-time">
                    {{ ii.orderReceiveTime }}
                  </div>
                </div>
                <div class="flow-item-content-body-item" :class="ii.orderAuditTime ? 'blueBackColor' : 'grayBackColor'">
                  <!-- 实验接单 -->
                  <div class="flow-item-header">{{ h_i18n('de6ecaf5eab587fbc5fe2be3618ff040') }}</div>
                  <div class="flow-item-time">
                    {{ ii.orderAuditTime }}
                  </div>
                </div>
                <div class="flow-item-content-body-item" :class="ii.inspectActualFinishDate ? 'blueBackColor' : 'grayBackColor'">
                  <!-- 实验测试 -->
                  <div class="flow-item-header">{{ h_i18n('698c44e467a3d91264af8d6afd854b06') }}</div>
                  <div class="flow-item-time">
                    {{ ii.inspectActualFinishDate }}
                  </div>
                </div>
                <div class="flow-item-content-body-item" :class="ii.reportPublishTime ? 'blueBackColor' : 'grayBackColor'">
                  <!-- 检验结论 -->
                  <div class="flow-item-header">{{ h_i18n('cb3b7c13f71828fc659149599a5b2a35') }}</div>
                  <div class="flow-item-time">
                    {{ ii.reportPublishTime }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-drawer>
      <div style="width: 100%;display: flex;justify-content: space-between;">
        <div style="display: flex;">
        </div>
        <div style="display: flex;">
          <div style="width: 100%;display: flex;margin-right: 8px;">
            <div style="width:20px;border-radius:5px;background-color:#00C853;height:12px;margin-top: 5px;margin-right: 8px;"></div>
            <div style="width:60px;">已完成</div>
          </div>
          <div style="width: 100%;display: flex;margin-right: 8px;">
            <div style="width:20px;border-radius:5px;background-color:#FF7D00;height:12px;margin-top: 5px;margin-right: 8px;"></div>
            <div style="width:60px;">进行中</div>
          </div>
          <div style="width: 100%;display: flex;margin-right: 8px;">
            <div style="width:20px;border-radius:5px;background-color:#722ED1;height:12px;margin-top: 5px;margin-right: 8px;"></div>
            <div style="width:60px;">待执行</div>
          </div>
          <div style="width: 100%;display: flex;margin-right: 8px;">
            <div style="width:20px;border-radius:5px;background-color:#F53F3F;height:12px;margin-top: 5px;margin-right: 8px;"></div>
            <div style="width:60px;">不合格</div>
          </div>
          <div style="width: 100%;display: flex;margin-right: 8px;">
            <div style="width:20px;border-radius:5px;background-color:#EDEFF2;height:12px;margin-top: 5px;margin-right: 8px;"></div>
            <div style="width:80px;">无需处理</div>
          </div>
        </div>
      </div>
        

    </el-drawer>

    <!-- 模板库资料上传；模板库资料查看 -->
    <h-dialog :show="templetShowFlag" :title="TempletBtnFlag ? h_i18n('c2620c9a894b90f916e967f938fee9f3') : h_i18n('6f8671d19993689a8ca83bc0eca7cf91')" footer @close="dialogClose" width="70%"
      class="tempUp_dialog_style">
        <!-- 模板库资料 -->
        <form-header :title="h_i18n('5224dc5b23899579541c61008a2b0f59')" title-height="80px" style="margin-top:8px;" v-loading="templetLoading">
          <template #body>
            <!-- 模板库属性 -->
            <h-tr>{{ h_i18n('eda1ed64d0b056b855397956d73f02c4') }}</h-tr>
            <tr v-if="getData.model.queryFlag == 'film'">
              <!-- 大类；盘膜 -->
              <report-td :title="h_i18n('d196c72826e21cb830aad6aed32478db')" colspan="4:4">{{ h_i18n('e86da95db59395cf9770af483fde29b5') }}</report-td>
              <!-- 材质 -->
              <report-td :title="h_i18n('e3623348d276b8fa54e772581fac9cae')" colspan="4:4">{{ getData.model.material }}</report-td>
              <!-- 胶型 -->
              <report-td :title="h_i18n('5f84a2040ec3476882e06ed9baec08e3')" colspan="4:4">{{ getData.model.glue }}</report-td>
            </tr>
            <tr v-if="getData.model.queryFlag == 'film' && !TempletBtnFlag">
              <!-- 模板库ID -->
              <report-td :title="h_i18n('d8861b4035e7616b0650b10f35282a8d')" colspan="4:20">{{ getData.templetId }}</report-td>
            </tr>
            <tr v-if="getData.model.queryFlag == 'instruc'">
              <!-- 大类；说明书 -->
              <report-td :title="h_i18n('d196c72826e21cb830aad6aed32478db')" colspan="4:4">{{ h_i18n('1f08ac8f42c807aa697b5c721dd69165') }}</report-td>
              <!-- 颜色 -->
              <report-td :title="h_i18n('6b36c6f7ec834692ec6c8e3816349fdd')" :colspan="TempletBtnFlag ? '4:12' : '4:4'">{{ getData.model.colorOne }}</report-td>
              <!-- 模板库ID -->
              <report-td :title="h_i18n('d8861b4035e7616b0650b10f35282a8d')" v-if="!TempletBtnFlag" colspan="4:4">{{ getData.templetId }}</report-td>
            </tr>
            <tr v-if="getData.model.queryFlag == 'pop'">
              <!-- 大类 -->
              <report-td :title="h_i18n('d196c72826e21cb830aad6aed32478db')" colspan="4:4">POP</report-td>
              <!-- 材质 -->
              <report-td :title="h_i18n('e3623348d276b8fa54e772581fac9cae')" :colspan="TempletBtnFlag ? '4:12' : '4:4'">{{ getData.model.typeOne }}</report-td>
              <!-- 模板库ID -->
               <report-td :title="h_i18n('d8861b4035e7616b0650b10f35282a8d')" v-if="!TempletBtnFlag" colspan="4:4">{{ getData.templetId }}</report-td>

            </tr>
            <tr v-if="getData.model.queryFlag == 'sticker'">
              <!-- 大类；不干胶贴 -->
              <report-td :title="h_i18n('d196c72826e21cb830aad6aed32478db')" colspan="4:4">{{ h_i18n('cc14f91613bf7e8f816ff7a6a825e1c2') }}</report-td>
              <!-- 材质 -->
              <report-td :title="h_i18n('e3623348d276b8fa54e772581fac9cae')" colspan="4:4">{{ getData.model.material }}</report-td>
              <!-- 颜色 -->
              <report-td :title="h_i18n('6b36c6f7ec834692ec6c8e3816349fdd')" colspan="4:4">{{ getData.model.color }}</report-td>
            </tr>
            <tr v-if="getData.model.queryFlag == 'sticker'">
              <!-- 工艺 -->
              <report-td :title="h_i18n('ec9875c10f408999de612355983da20c')" colspan="4:4">{{ getData.model.technology }}</report-td>
              <!-- 用途 -->
              <report-td :title="h_i18n('9c5d49bda7000887a8d10670ef1b1ed7')" :colspan="TempletBtnFlag ? '4:12' : '4:4'">{{ getData.model.bakOne }}</report-td>
               <!-- 模板库ID -->
               <report-td :title="h_i18n('d8861b4035e7616b0650b10f35282a8d')" v-if="!TempletBtnFlag" colspan="4:4">{{ getData.templetId }}</report-td>

            </tr>
            <tr v-if="getData.model.queryFlag == 'carton'">
              <!-- 类别 -->
              <report-td :title="h_i18n('383a6d166f8f60e16e726ccc9c483631')" colspan="4:4">{{ getData.model.category }}</report-td>
              <!-- 瓦楞类型 -->
              <report-td :title="h_i18n('B93E049754A3CA6A8FA1F4CF986A53FB')" colspan="4:4">{{ getData.model.fluteType }}</report-td>
              <!-- <report-td :title="h_i18n('D6DB2072CBCC214F4D1FAFF6E58C78E8')" colspan="4:4">{{ getData.model.internalLength }}</report-td>
            </tr>
            <tr v-if="getData.model.queryFlag == 'carton'">
              <report-td :title="h_i18n('D84B4767A7C8B781D735629880862BC2')" colspan="4:4">{{ getData.model.internalHeight }}</report-td>
              <report-td :title="h_i18n('93D61B5D9249964403EABBF6D94E113B')" colspan="4:4">{{ getData.model.internalWidth }}</report-td> -->
              <!-- 规格 -->
              <report-td :title="h_i18n('ea887bd098de889dff3208a64d2b67e3')" colspan="4:4">{{ getData.model.specification }}</report-td>
            </tr>
            <tr v-if="getData.model.queryFlag == 'carton'">
              <!-- 纸箱结构 -->
              <report-td :title="h_i18n('1042E7C4E324DA82D65177C4D247AA22')" :colspan="TempletBtnFlag ? '4:20' : '4:4'">{{ getData.model.cartonStructure }}</report-td>
              <!-- 模板库ID -->
              <report-td :title="h_i18n('d8861b4035e7616b0650b10f35282a8d')" v-if="!TempletBtnFlag" colspan="4:12">{{ getData.templetId }}</report-td>
            </tr>

            <!-- 模板库项目 -->
            <h-tr>{{ h_i18n('5c1fdc0499d6971eb7111b473f98e6d6') }}</h-tr>
            <tr class="info_table_style">
              <!-- 序号 -->
              <td colspan="2">{{ h_i18n('faaadc447b1c2b1adc920d9c9aedcc25') }}</td>
              <td colspan="2">*</td>
              <!-- 项目 -->
              <td colspan="6">{{ h_i18n('31ecc0e65b4cd3e6b12577382bb56d6a') }}</td>
              <!-- 附件 -->
              <td colspan="12">{{ h_i18n('c9a6ee90f5d43732e3f6cf4dcaa8493c') }}</td>
              <!-- 结论 -->
              <td colspan="2">{{ h_i18n('54bbba803f13eaab0f5441d97b13247a') }}</td>
            </tr>
            <template v-for="(item,index) in documentList" :key="item.documentId">
              <tr class="info_table_body_style">
                <td colspan="2">{{ index + 1}}</td>
                <td colspan="2">
                  <span v-if="item.isNeed == 'Y'" class="dangerColor">*</span>
                </td>
                <td colspan="6">
                  <span>{{ item.documentName }}</span>
                </td>
                <td colspan="12">
                  <hc-file-upload v-if="TempletBtnFlag && tempFileUp" :info="h_i18n('0a94aa92aebd0d07cd2fffcb3c3b545f')" v-model="tempFile[index]" :disabled="disabledFlag"
                    delete download @change="fileUpChange($event,item,index)" @delete="deleteFile(index,item)" @error="error" @download="downLoadFile(item.fileId,item.fileName)">
                  </hc-file-upload>
                  <span v-else @click="downLoadFile(item.fileId,item.fileName)"
                    style="color: #2164f5; cursor: pointer; text-overflow: ellipsis; overflow: hidden; display: block">
                  {{ item.fileName }}
                  </span>
                </td>
                <td colspan="2">
                  <!-- 不合格 -->
                  <span class="dangerColor" v-if="item.conclusion === 'F'">{{ h_i18n('6e5a122013138ad189517d5d0a1c0891') }}</span>
                  <!-- 合格 -->
                  <span v-else>{{ h_i18n('86f720320b77bb62311f0a4811db04fe') }}</span>
                  <!-- <el-select v-model="item.conclusion" @change="changeFun($event,item)">
                    <el-option value="P" label="P"></el-option>
                    <el-option value="F" label="F"></el-option>
                  </el-select> -->
                </td>
              </tr>
            </template>
            <tr v-if="getData.patternPlan.selfCheckState == 2228">
              <!-- 打回备注 -->
              <report-td :title="h_i18n('c811b6a0427ea764d9cf1c52bff7d0aa')" colspan="4:20">{{ getData.patternPlan.supplyCheckMark }}</report-td>
            </tr>
          </template>
        </form-header>
        <template #footer>
            <h-button-group align="center">
              <!-- 保存 -->
              <h-button type="primary" v-if="TempletBtnFlag" @click="saveBtn()" :loading="saveLoading" :disabled="saveBtnDisabled">{{ h_i18n('be5fbbe34ce9979bfb6576d9eddc5612') }}</h-button>
              <!-- 返回 -->
              <h-button type="primary" v-else @click="dialogClose()">{{ h_i18n('5f411223ca5a01a5adf20fe735a433d0') }}</h-button>
            </h-button-group>
        </template>
    </h-dialog>

    <!-- 制版设计稿上传 -->
    <h-dialog :show="pictureShowFlag" :title="h_i18n('65d2b4cc69ee0d7fa8706a074b5b2b39')" footer @close="dialogClose" width="70%"
      class="picUp_dialog_style">
      <!-- 制版设计稿上传 -->
      <form-header :title="h_i18n('65d2b4cc69ee0d7fa8706a074b5b2b39')" title-height="80px" style="margin-top:8px;" v-loading="templetLoading">
        <template #body>
          <tr>
            <!-- 制版设计稿上传 -->
            <report-td :title="h_i18n('65d2b4cc69ee0d7fa8706a074b5b2b39')" colspan="4:20">
              <hc-file-upload :info="h_i18n('a14efa27c74b8de344fb306f9e2bc3bc')" v-model="tempFile[101]" size="50"
                delete download @change="fileUpChange($event,rowData,101)" @delete="deleteFile(101,rowData)" @error="error" @download="downLoadFile(pictureFileId,pictureFileName)">
              </hc-file-upload>
            </report-td>
          </tr>
        </template>
      </form-header>
      <template #footer>
            <h-button-group align="center">
              <!-- 保存 -->
              <h-button type="primary" @click="saveBtnP()" :loading="saveLoading">{{ h_i18n('be5fbbe34ce9979bfb6576d9eddc5612') }}</h-button>
            </h-button-group>
        </template>
    </h-dialog>
    <!-- 送样历史记录 -->
    <h-dialog :show="historyShow" :title="h_i18n('480314fec74c7ad31c65e15658d015fa') + h_i18n('c827d8dbb76ce33219f64c6749893159')" 
       @close="historyCancel" width="70%" class="picUp_dialog_style">
      <div class="history-table">
        <!-- 暂无数据 -->
        <el-table :data="historyTable" v-loading="historyLoading" :empty-text="h_i18n('21efd88b67a39834582ad99aabb9dc60')" 
          height="540" border size="small" style="width: 100%;min-height: 340px;">
          <!-- 序号 -->
          <el-table-column type="index" :label="h_i18n('faaadc447b1c2b1adc920d9c9aedcc25')" width="62"></el-table-column>
          <!-- 状态 -->
          <el-table-column prop="sampleStatus" :label="h_i18n('3fea7ca76cdece641436d7ab0d02ab1b')" width="80">
             <template #default="{ row }">
               <!-- 打回 -->
               <el-tag size="small" v-if="row.sampleStatus === 2221" type="danger">{{ h_i18n('9a7b15dccc5cda2e3db1110678576104') }}</el-tag>
               <!-- 通过 -->
               <el-tag size="small" v-else-if="row.sampleStatus === 2222" type="success">{{ h_i18n('23c1f39900b3af4c3263449782e288e1') }}</el-tag>
               <span v-else>-</span>
             </template>
          </el-table-column>
          <!-- 供方计划送样时间 -->
          <el-table-column prop="supplierSendFactorySamplePlanDate" :label="h_i18n('8e20b70327602db813a03df90b7a9ed8')" width="150" >
            <template #default="{ row }">{{ row.supplierSendFactorySamplePlanDate ? formDate(row.supplierSendFactorySamplePlanDate, 3) : '-' }}</template>
          </el-table-column>
          <!-- 供方送样人 -->
          <el-table-column prop="supplySendSampleMan" :label="h_i18n('6a52ae8d38d65d94a9673129041ca156')" width="120" >
            <template #default="{ row }">{{ row.supplySendSampleMan || '-' }}</template>
          </el-table-column>
          <!-- 供方送样数量 -->
          <el-table-column prop="supplySendSampleNumber" :label="h_i18n('0a5b1df588a1e061097183d52c2d585b')" width="120">
            <template #default="{ row }">{{ row.supplySendSampleNumber || '-' }}</template>
          </el-table-column>
          <!-- 送样方式 -->
          <el-table-column prop="deliveryType" :label="h_i18n('195fe52c72f3f8c6be34c497b47c94bc')" width="100" ></el-table-column>
          <!-- 快递单号 -->
          <el-table-column prop="deliveryNo" :label="h_i18n('3c016d36581bc71c027386cbf617722f')" width="150" >
            <template #default="{ row }">{{ row.deliveryNo || '-' }}</template>
          </el-table-column>
          <!-- 预计送样时间 -->
          <el-table-column prop="planDeliveryDate" :label="h_i18n('5ad67a9e2faec80e40f03e924c59dc43')" width="150" >
            <template #default="{ row }">{{ row.planDeliveryDate ? formDate(row.planDeliveryDate, 3) : '-' }}</template>
          </el-table-column>
          <!-- 送样拖期原因 -->
          <el-table-column prop="sendSampleDelayReason" :label="h_i18n('01A3AD4C38FDCDB333EF79759E011F67')" width="150" >
            <template #default="{ row }">
               {{ resonName(row.sendSampleDelayReason) || '-'}}
            </template>
          </el-table-column>
          <!-- 送样拖期其他原因说明 -->
          <!-- 送样拖期其它原因说明 -->
          <el-table-column prop="sendSampleDelayReasonRemark" :label="h_i18n('D5D682769E2FD411333DB100B9A6AD3E')" width="190" >
            <template #default="{ row }">{{ row.sendSampleDelayReasonRemark || '-' }}</template>
          </el-table-column>
          <!-- 送样样件照片 -->
          <el-table-column prop="samplePicture" :label="h_i18n('1bde84c9de69d3fb8ad01e70a14455df')" width="320" class-name="photoColumn" >
            <template #default="{ row }">
              <template v-for="(item, i) in typePicture(row.samplePicture)" :key="i">
                <a :href="$filePathSplicing(item.filePath)" target="_blank" style="display:none;"></a>
                <el-image :src="$filePathSplicing(item.filePath, 'img')" :preview-src-list="typePicture(row.samplePicture).map(u => $filePathSplicing(u.filePath, 'img'))"
                  style="width:27px ; height:27px;margin-right: 2px; vertical-align: text-top;object-fit:fill;border-radius: 4px;"
                  fit="fill" preview-teleported="true">
                </el-image>
              </template>
            </template>
          </el-table-column>
          <!-- 实际送样时间 -->
          <el-table-column prop="supplySendSampleDate" :label="h_i18n('3f35655dd0d0598a1441faad74ac5d40')" width="150" >
            <template #default="{ row }">{{ row.supplySendSampleDate ? formDate(row.supplySendSampleDate, 3) : '-' }}</template>
          </el-table-column>
          <!-- 收样数量 -->
          <el-table-column prop="iqcReceiveSampleNumber" :label="h_i18n('f9c946f168fef4b7ac270ad2dee628fb')" width="100">
            <template #default="{ row }">{{ row.iqcReceiveSampleNumber || '-' }}</template>
          </el-table-column>
          <!-- 收样时间 -->
          <!-- 检验收样时间 -->
          <el-table-column prop="sqeAffirmDate" :label="h_i18n('296b2d40f689d423ab3dd66889c76fde')" width="150" >
            <template #default="{ row }">{{ row.sqeAffirmDate ? formDate(row.sqeAffirmDate, 3) : '-' }}</template>
          </el-table-column>
          <!-- 收样意见 -->
          <el-table-column prop="sqeAffirmMark" :label="h_i18n('b9bca46ff88c72b2d00059ff9b2ed396')" width="200" >
            <template #default="{ row }">{{ row.sqeAffirmMark || '-' }}</template>
          </el-table-column>
        </el-table>
      </div>
    </h-dialog>
  </h-list-page>
</template>



<script>
//Automatic script writing.
import h_i18n from '@/utils/Internationalization';


import axios from "axios";
import DistanceController from "../../../views/Templates/distance/DistanceController";
// import flowList from "../config/flow";

export default {
  name: "NewProductInspectionApplication",
  data() {
    return {
      historyShow:false,// 送样历史弹窗
      historyTable: [],
      historyLoading: false,
      saveBtnDisabled:false, // 是否禁用模板保存按钮
      tempFileUp:false, // 是否能上传模板
      disabledDate(time) {
        //最小日期是当前日期
        return time.getTime() < Date.now() - 8.64e7;
      },
      sendSampleDelayReasonShow:false, // 送样拖期 是否显示
      sendSampleDelayReasonData:[],// 送样拖期列表
      sendSampleDelayReasonRemarkShow:false, // 送样拖期原因输入 是否显示

      selfDelayReason:'',  // 自检拖期原因
      selfDelayReasonRemark:'', // 自检拖期自定义原因
      selfDelayReasonData:[],  // 自检拖期列表
      // selfDelayReasonShow:false,// 自检拖期原因输入 是否显示
      // selfDelayReasonRemarkShow:false,// 自检拖期自定义原因输入 是否显示
      btnListOfSqm:[],
      fileNewStatus:[],
      fileStatus: [
        // {value: "2226", label: "自检待上传"},
        // {value: "2248", label: "自检待批准"},
        // {value: "2249", label: "自检批准驳回"},
        // {value: "2227", label: "自检待审核"},
        // {value: "2228", label: "自检审核驳回"},
        // {value: "2229", label: "自检待校核"},
        // {value: "2230", label: "自检合格"},
        // {value: "2236", label: "自检不合格"},
        // {value: "2247", label: "有效期内合格"},
      ],
      materialStatus: [
        // {value: "2219", label: "待供方送工厂样"},
        // {value: "2220", label: "待外检收样"},
        // {value: "2221", label: "外检收样打回"},
        // {value: "2222", label: "待型检"},
        // {value: "2223", label: "物料结论待校核"},
        // {value: "2224", label: "物料结论校核合格"},
        // {value: "2237", label: "物料结论校核不合格"},
      ],
      inspectionMethod: [
        // {value: "1104", label: "新品标准检"},
        // {value: "1105", label: "新品免检"},
        // {value: "1106", label: "新品加速检"},
        // {value: "1141", label: "新品停检"},
      ],
      supplyCheckList: [
        {value: "1010", label: "AQC"},
        {value: "1011", label: "BQC"},
        {value: "1012", label: "RQC"},
        {value: "1153", label: "LQC"},
      ],
      pictureStatus:[ // 制版设计稿状态
        // {value:'1432',label:'待上传'},
        // {value:'1433',label:'待审核'},
        // {value:'1434',label:'型号经理审核打回'},
        // {value:'1435',label:'型号经理审核通过'}
      ],
      searchData: {
        mtlNo: "",
        supplyCode: ""
      },
      status: false,

      buttonList: [],//按钮权限
      factoryReportList: [],//此订单关联的生产批次报告信息
      tableDataList: [],//列表list
      departureListPlanList: [],//发车单list
      reasonForConversionList: [],//转换原因list
      multipleSelection: [],//选中数据
      mtlNoList: [],//模糊查询专用号list
      supplyCodeList: [],//供应商模糊查询list
      inspectionManagerList: [],//外检经理
      pageType: "zdjy",//公用页面标识
      loading: {
        exportLoading: false,//导出
        qualityInspectionLoading: false,//解质检库存
        tableListLoading: false,//列表
        factoryReportLoading: false,//此订单关联的生产批次报告信息
        departureListPlanLoading: false,//发车单状态
        mtlLoading: false,//专用号查询
        supplyLoading: false,//供应商查询
      },
      materielCategoryNameList: [],//物料大类
      sybList: [],//工厂小微
      pageNation: {
        pageIndex: 1,
        pageSize: 10,
        total: 0,
      },
      http: {
        searchHttp: null,//查询列表--避免重复请求数据覆盖的问题
        departureListHttp: null,//发车单状态
        mtlSearchHttp: null,//专用号模糊查询
        supplySearchHttp: null,//供应商模糊查询
        reasonForConversionHttp: null,//转换原因
      },

      name: "",
      plan: {
        factoryReportPlan: false,//此订单关联的生产批次报告信息弹出框面板
        reasonForConversionPlan: false,//转换原因
        divideTheWorkPlan: false,//分工
      },
      followCard: {show: false, width: 500, height: 200},
      divideTheWork: {checkManagerId: ""},
      planBlur: false,
      timeout: {
        departureNote: null
      },
      dateMap: {
        sendDay: null,
        supplierSendFactorySamplePlanDate: null,
        supplySendSampleDate: null,
      },
      drawer: false,
      drawerLog: false,
      sampleDelivery: {
        supplySendSampleDate: "",
        planDeliveryDate: "",
        supplySendSampleMan: "",
        supplySendSampleNumber: "",
        // 快递
        deliveryType: h_i18n('705d54db81f6eaf23b9c56eb0b4b40d4'),
        deliveryNo: "",
        sendSampleDelayReason:'', // 送样拖期原因
        sendSampleDelayReasonRemark:'',  // 送样拖期自定义原因
      },
      fileUploadM: false,
      fileList: [],
      fileListOld: [],
      pictureL: false,
      pictureList: [],
      sampleDeliveryLoading: false,
      roleCode: "",
      logList: [],
      fileListOld: [],
      logLoading: false,
      flowList: [],
      flowControlList: [],
      flow_content: 650,
      flow_insert: false,
      flow: false,
      getData:{
        model:{},
        patternPlan:{}
      },
      documentList:[],
      templetLoading:false,
      templetShowFlag:false,
      tempFile:[],
      rowData:null,
      TempletBtnFlag:false,
      pictureShowFlag:false,
      supplyList:["V14419", "V14252", "V12999", "V13026", "V13336", "V14353", "V14318", "V14199", "V12858", "V13794", "V14011", "V13093", "V12437", "V12295", "V14182", "V14326", "V67251", "V54260", "V14513", "V14531", "V14434", "V14463", "V14579", "V14811",
        "V14644","V14837","V13841","V14559","V14092","V14681","V14950","V14833","V15142"],
      templetFlag:false,
      saveLoading:false,
      disabledFlag:false,
    }
  },
  computed: {
    clearAble() {
      let list = Object.keys(this.dateMap)

      let a = list.filter(v => {
        return !!this.dateMap[v];
      })
      return a.length > 1;
    }
  },

  methods: {
    h_i18n,
    async loadFlowList () {
      try {
        const { default: flowList } = await import('../config/flow')
        return flowList
      } catch (error) {
          console.error('加载模块时出错:', error);
      }
  },
    // 流程图 开始
    async flowOpened() {
      // let instance = DistanceController.GetInstance("flowContent", flowList)
      let instance = DistanceController.GetInstance("flowContent", await this.loadFlowList())
      instance.show()
      this.flowList.forEach(v => {
        instance.update(v.id, v.content)
      })
      this.flowControlList.forEach(v => {
        instance.update(v.id, v.status)
      })
      instance.review()
      this.instanceTemp = instance
    },
    flowPlan(row) {
      this.rowData = row
      // 流程查询中...
      this.startLoading(h_i18n('14eecb4675218b6a3ab7ac2537540edb'))
      this.flowList = []
      this.$http({
        method: "get",
        url: "/base/patternPlan/searchPatternPlanInfo?patternPlanId=" + row.patternPlanId,
      }).then(res => {
        if (res.data.code !== "200") {
          this.flow = false
          // 流程图查询失败
          this.error(h_i18n('c5f997d45b90a0ac502a8431b5802e83'))
        }
        let data = res.data.data.patternPlan
        //主流程
        // 实：；实：--
        this.flowList.push({id: "20", content: [``,data.patternPlanStatus >= 2238 ? `${h_i18n('5e1979ad0f45d924cfd502618a33df30')}${this.time(data.careerConfirmDay, 3)}` : h_i18n('e74fde23cc31794e490a94880928c554')]})
        // 实：
        this.flowList.push({id: "21", content: [`${h_i18n('5e1979ad0f45d924cfd502618a33df30')}${this.time(data.sendDay, 3)}`]})
        // 实：
        this.flowList.push({id: "22", content: [``, `${h_i18n('5e1979ad0f45d924cfd502618a33df30')}${this.timeC(data.divideFactDate, 3)}`]})
        if(data.patternPlanStatus == 2218){
          // 应：；实：
          this.flowList.push({id: "23", content: {content:[`${this.flowSchedule(data.iqcManagerName)}`, `${h_i18n('a42a12540ed5c0edb159624c70e1bd2f')}${this.timeC(data.normPlanDate, 3)}`,`${h_i18n('5e1979ad0f45d924cfd502618a33df30')}${this.timeC(data.normFactDate, 3)}`],
          // 专用号依据
          link:{text: h_i18n('33eab55f76de2e52cc1c202d7c14692a'), callback: () => this.$router.push({name:'EnterpriseStandardList',query:{
            mtlNo: row.mtlNo,
            supplyCode: row.supplyCode
          }})}}})
        }else{
          // 应：；实：
          this.flowList.push({id: "23", content: [`${this.flowSchedule(data.iqcManagerName)}`, `${h_i18n('a42a12540ed5c0edb159624c70e1bd2f')}${this.timeC(data.normPlanDate, 3)}`,`${h_i18n('5e1979ad0f45d924cfd502618a33df30')}${this.timeC(data.normFactDate, 3)}`]})
        }
        //物料流程
        // 应：；实：
        this.flowList.push({id: "24", content: [`${this.flowSchedule(data.supplySendSampleMan)}`, `${h_i18n('a42a12540ed5c0edb159624c70e1bd2f')}${this.timeC(data.supplierSendFactorySamplePlanDate, 3)}`, `${h_i18n('5e1979ad0f45d924cfd502618a33df30')}${this.timeC(data.supplySendSampleDate, 3)}`]})
        // 应：；实：
        this.flowList.push({id: "25", content: [``, `${h_i18n('a42a12540ed5c0edb159624c70e1bd2f')}${this.timeC(data.planReceiveDate, 3)}`, `${h_i18n('5e1979ad0f45d924cfd502618a33df30')}${this.timeC(data.sqeAffirmDate, 3)}`]})
        this.flowList.push({
          id: "26",
          content: {
            // 应：；实：
            content: [``, `${h_i18n('a42a12540ed5c0edb159624c70e1bd2f')}${this.timeC(data.wjPlanCheckDate, 3)}`, `${h_i18n('5e1979ad0f45d924cfd502618a33df30')}${this.timeC(data.checkCompleteDate, 3)}`],
            // 实验流程追踪
            link: {text: h_i18n('0f6634460c8378eb46405d6afad4c330'), callback: () => this.flowContent(row)}
          }
        })
        // 应：；实：
        this.flowList.push({id: "27", content: [``, `${h_i18n('a42a12540ed5c0edb159624c70e1bd2f')}${this.timeC(data.iqcLeaderAuditPlanDate, 3)}`, `${h_i18n('5e1979ad0f45d924cfd502618a33df30')}${this.timeC(data.iqcLeaderAuditDate, 3)}`]})
        /* 开发结论 
        节点完成时间（应）：careerConclusionPlanDate
        节点完成时间（实）： careerConclusionDate
        开发结论时间（结论）： careerConclusionFinishDate
        */
        // 实：
        this.flowList.push({id: "28", content: [``, `${h_i18n('5e1979ad0f45d924cfd502618a33df30')}${this.timeC(data.careerConclusionDate, 3)}`]})
        //分支流程-文件流程
        // 应：；实：
        this.flowList.push({id: "14", content: [`${this.flowSchedule(data.selfCheckMan)}`, `${h_i18n('a42a12540ed5c0edb159624c70e1bd2f')}${this.timeC(data.supplierSelfCheckPlanDate, 3)}`, `${h_i18n('5e1979ad0f45d924cfd502618a33df30')}${this.timeC(data.selfCheckDate, 3)}`]})
        // 应：；实：
        this.flowList.push({id: "15", content: [``, `${h_i18n('a42a12540ed5c0edb159624c70e1bd2f')}${this.timeC(data.planSupplyCheckDate, 3)}`, `${h_i18n('5e1979ad0f45d924cfd502618a33df30')}${this.timeC(data.supplyCheckDate, 3)}`]})
        // 应：；实：
        this.flowList.push({id: "16", content: [``, `${h_i18n('a42a12540ed5c0edb159624c70e1bd2f')}${this.timeC(data.iqcLeaderAuditPlanDate, 3)}`, `${h_i18n('5e1979ad0f45d924cfd502618a33df30')}${this.timeC(data.iqcLeaderAuditDate, 3)}`]})

        // 制版设计稿流程
        // 实：
        this.flowList.push({id: "31", content: [`${this.flowSchedule(data.pictureSubmitMan)}`, `${h_i18n('5e1979ad0f45d924cfd502618a33df30')}${this.timeC(data.pictureFileTime, 3)}`]})
        // 应：；实：
        this.flowList.push({id: "32", content: [``, `${h_i18n('5e1979ad0f45d924cfd502618a33df30')}${this.timeC(data.pictureCheckTime, 3)}`]})
        //处理流程状态
        this.flowControlList = this.flowControl(data)
        this.flow = true
        this.closeLoading()


      }).catch(e => {
        this.flow = false
        // 流程图查询失败
        this.error(h_i18n('c5f997d45b90a0ac502a8431b5802e83') + e)
      })
    },
    flowSchedule(v) {
      return v ? v : "--"
    },
    timeC(v, i = 3) {
      return v ? this.time(v) : "--"
    },
    flowContent(row) {
      //查询实验报告
      // 实验流程查询
      this.startLoading(h_i18n('55dad963ce47b01b5587e1a628922467'))
      this.$http({
        method: "get",
        url: "/base/patternPlan/getLimsList?patternPlanId=" + row.patternPlanId,
      }).then(res => {
        if (res.data.code === "200") {
          if (res.data.data.length > 0) {
            // let limsUrl = ''
            // if (process.env.NODE_ENV == 'production'){
            //   // limsUrl = 'https://mom.haier.net/limsclientrest/hmqm/order/findHisByCode'
            //   limsUrl = '/limsApi/order/findHisByCode'
            // }else {
            //   limsUrl = 'https://qm.haier.net/limsclientrest/hmqm/order/findHisByCode'
            //   // limsUrl = '/lims/limsclientrest/hmqm/order/findHisByCode'
            // }
            this.$http({
              method:'get',
              url:"/base/testTask/findHisByCode"+"?orderCode="+res.data.data.toString(),
            }).then(res=>{
              if(res.data && res.data.length > 0){
                this.flow_content = 700
                this.flow_insert = true
                this.testList = res.data
              }
            })
          } else {
            // 暂无实验流程
            this.info(h_i18n('074cad5276eae5529adbbd3248f88335'))
          }
        } else {
          // 实验流程查询失败
          this.info(h_i18n('35bb5b9f67afb4c0c64e9dbc2cfe9f63'))
        }
        this.closeLoading()
      })
    },
    /**
     * 流程控制
     * @param data
     */
    flowControl(data) {
    // 型号经理收样后 新品状态patternPlanStatus 2238  为新品验证中 判断文件selfCheckState /物料checkStatusId/制版设计稿pictureCheckState状态，如果无状态就是不走相对流程，置灰。
      // 开发结论： 新品状态patternPlanStatus 为待开发验证 2239 /开发验证合格 2240/开发验证不合格 2241 时到此状态
      let statusList = []
      if(process.env.VUE_APP_ENV !== 'production'){
        console.log('patternPlanStatus>>>>>>>>>>>>>>新品状态:',data?.patternPlanStatus)
        console.log('selfCheckState>>>>>>>>>>>>>>文件:',data?.selfCheckState)
        console.log('checkStatusId>>>>>>>>>>>>>>物料:',data?.checkStatusId)
        console.log('pictureCheckState>>>>>>>>>>>>>>制版设计稿:',data?.pictureCheckState)
      }
      // 流程顺序
      // （中间） 21 样检单下达 22 检验分工 23 标准维护 20 型号经理收样
      // 并行流程
      // （中间） 物料： 24 供方送样 25 外检收样 26 检验 27 物料结论
      // （上） 文件： 14 供方自检 15 外检审核 16 文件结论 
      // （下） 制版设计稿： 31 供方上传 32 型号经理审核 
      // （中间）28 开发结论 29 小批
      
      let firstList = ['21','22','23','20']
      let upIdArry = ['14','15','16']
      let midIdArry = ['24','25','26','27']
      let downIdArry = ['31','32']
      let lastArray = ['28']

      // 物料状态
      const statusToColorFunMid = (flowId) => {
          let index = midIdArry.indexOf(flowId)
          if(index !== -1){
            let midIdArryLift = midIdArry.slice(0,index)
            for(let i = 0 ; i < midIdArryLift.length ; i ++){
              statusList.push({id: midIdArryLift[i], status: "success"})
            }
            let midIdArryRight = midIdArry.slice(index+1)
            for(let i = 0 ; i < midIdArryRight.length ; i ++){
              statusList.push({id: midIdArryRight[i], status: "loading"})
            }
          }
          statusList.push({id: flowId, status: "warning"})
        }
        // 文件状态
        const statusToColorFunUp = (flowId) => {
          let index = upIdArry.indexOf(flowId)
          if(index !== -1){
            let upIdArryLeft = upIdArry.slice(0,index)
            for(let i = 0 ; i < upIdArryLeft.length ; i ++){
              statusList.push({id: upIdArryLeft[i], status: "success"})
            }
            let upIdArryRight = upIdArry.slice(index+1)
            for(let i = 0 ; i < upIdArryRight.length ; i ++){
              statusList.push({id: upIdArryRight[i], status: "loading"})
            }
          }
          statusList.push({id: flowId, status: "warning"})
        }
        // 制版设计稿状态
        const statusToColorFunDown = (flowId) => {
          let index = downIdArry.indexOf(flowId)
          if(index !== -1){
            let downIdArryLeft = downIdArry.slice(0,index)
            for(let i = 0 ; i < downIdArryLeft.length ; i ++){
              statusList.push({id: downIdArryLeft[i], status: "success"})
            }
            let downIdArryRight = downIdArry.slice(index+1)
            for(let i = 0 ; i < downIdArryRight.length ; i ++){
              statusList.push({id: downIdArryRight[i], status: "loading"})
            }
          }
          statusList.push({id: flowId, status: "warning"})
        }
        // 共有流程
        const statusToColorPub = (flowId) => {
          let index = firstList.indexOf(flowId)
          if(index !== -1){
            let firstListLeft = firstList.slice(0,index)
            for(let i = 0 ; i < firstListLeft.length ; i ++){
              statusList.push({id: firstListLeft[i], status: "success"})
            }
            let firstListRight = firstList.slice(index+1)
            for(let i = 0 ; i < firstListRight.length ; i ++){
              statusList.push({id: firstListRight[i], status: "loading"})
            }
          }
          statusList.push({id: flowId, status: "warning"})
        }

        // 三流程渲染
        const UMDstatusToColor = () => {
          if(!data.selfCheckState){ // 没有文件流程
            for(let i = 0 ; i < firstList.length ; i ++){
              statusList.push({id: firstList[i], status: "default"})
            }
          }else{
            switch(data.selfCheckState){
              case 2230 : // 自检合格
                for(let i = 0 ; i < upIdArry.length ; i ++){
                  statusList.push({id: upIdArry[i], status: "success"})
                }
                break
              case 2247 : // 有效期内合格
                for(let i = 0 ; i < upIdArry.length ; i ++){
                  statusList.push({id: upIdArry[i], status: "success"})
                }
                break
              case 2226 : // 自检待上传
                statusToColorFunUp('14')
                break
              case 2248 : // 自检待批准-供方
                statusToColorFunUp('14')
                break
              case 2249 : // 自检批准驳回-供方
                statusToColorFunUp('14')
                break
              case 2228 : // 自检审核驳回
                statusToColorFunUp('14')
                break
              case 2227 : // 自检待审核
                statusToColorFunUp('15')
                break
              case 2501 : // 自检校核驳回
                statusToColorFunUp('15')
                break
              case 2229 : // 自检待校核
                statusToColorFunUp('16')
                break
              case 2236 : // 自检不合格
                for(let i = 0 ; i < upIdArry.length -1 ; i ++){
                  statusList.push({id: upIdArry[i], status: "success"})
                }
                statusList.push({id: upIdArry[upIdArry.length -1], status: "danger"})
                break
            }
            // 链接折线

          }
          if(!data.checkStatusId){ // 主流程
            
          }else{
            switch(data.checkStatusId){
              case 2224 : // 物料结论校核合格 前面都success
                for(let i = 0 ; i < midIdArry.length ; i ++){
                  statusList.push({id: midIdArry[i], status: "success"})
                }
                break
              case 2223 : // 物料结论待校核
                statusToColorFunMid('27')
                break
              case 2237 : // 物料结论校核不合格
                statusToColorFunMid('27')
                // 物料检验不合格 不合格的颜色单独处理下
                statusList.push({id: '27', status: "danger"})
                break
              case 2222 : // 待型检
                statusToColorFunMid('26')
                break

              case 2220 : // 待外检收样
                statusToColorFunMid('25')
                break
              case 2221 : // 外检收样打回
                statusToColorFunMid('24')
                break
              case 2219 : // 待供方送工厂样
                statusToColorFunMid('24')
                break
              case 2502 : // 物料校核驳回
                statusToColorFunMid('26')
                break
            }

          }
          if(!data.pictureCheckState){
            for(let i = 0 ; i < downIdArry.length ; i ++){
              statusList.push({id: downIdArry[i], status: "default"})
            }
          }else {
            switch(data.pictureCheckState){
              case 1432 : // 待上传
                statusToColorFunDown('31')
                break
              case 1434 :  // 型号经理审核打回
                statusToColorFunDown('31')
                break
              case 1433 : // 待审核
                statusToColorFunDown('32')
                break
              case 1435 : // 型号经理审核通过
                statusList.push({id: downIdArry[0], status: "success"})
                statusList.push({id: downIdArry[1], status: "success"})
                break
              case 1836 : // 型号经理审核不合格
                statusList.push({id: downIdArry[0], status: "success"})
                statusList.push({id: downIdArry[1], status: "danger"})
                break
            }
            // 链接折线

          }
        }
      if(data?.patternPlanStatus === 2238){ // 新品验证中
        for(let i = 0 ; i < firstList.length ; i ++){
          statusList.push({id: firstList[i], status: "success"})
        }
        UMDstatusToColor()
      } else if(data?.patternPlanStatus === 2239) {
        // 待开发验证 
        statusList.push({id: lastArray[0], status: "warning"})
        // 如果制版设计稿存在 （待开发验证的必然已经走完文件/制版设计稿（如果有）流程。文件折线状态跟随开发结论节点样式。制版设计稿的因为不一定有，所以要单独处理。）
        if(data.pictureCheckState){
          setTimeout(() => { // 其他
            document.getElementById('line7').style.background = '#FF7D00'
            document.getElementById('line8').style.background = '#FF7D00'
          }, 500);
        }
        statusList.push({id: lastArray[1], status: "default"})
        for(let i = 0 ; i < firstList.length ; i ++){
          statusList.push({id: firstList[i], status: "success"})
        }
        UMDstatusToColor()
      }else if(data?.patternPlanStatus === 2241){
        // 开发验证不合格 流程结束
        statusList.push({id: lastArray[0], status: "danger"})
        statusList.push({id: lastArray[1], status: "default"})
        if(data.pictureCheckState){
          setTimeout(() => { // 其他
            document.getElementById('line7').style.background = '#F53F3F'
            document.getElementById('line8').style.background = '#F53F3F'
          }, 500);
        }
        for(let i = 0 ; i < firstList.length ; i ++){
          statusList.push({id: firstList[i], status: "success"})
        }
        UMDstatusToColor()
      }else if(data?.patternPlanStatus === 2240){
        // 开发验证合格
        statusList.push({id: lastArray[0], status: "success"})
        if(false){
          // 再开发验证合格前提下，只有需要小批的时候才有小批状态 尚未实现
          if('小批成功'){
            statusList.push({id: lastArray[1], status: "success"})
          }else if('小批失败'){
            statusList.push({id: lastArray[1], status: "danger"})
          }else if('小批待'){
            statusList.push({id: lastArray[1], status: "warning"})
          }
        }else{
          statusList.push({id: lastArray[1], status: "default"})
        }
        if(data.pictureCheckState){
          setTimeout(() => { // 其他
            document.getElementById('line7').style.background = '#00C853'
            document.getElementById('line8').style.background = '#00C853'
          }, 500);
        }
        for(let i = 0 ; i < firstList.length ; i ++){
          statusList.push({id: firstList[i], status: "success"})
        }
        UMDstatusToColor()
      }else if(data?.patternPlanStatus === 2217){
        // 待分工 22
        statusToColorPub('22')
      }else if(data?.patternPlanStatus === 2218){
        // 无标准 23
        statusToColorPub('23')
      }else if(data?.patternPlanStatus === 2216){
        // 有标准 20
        statusToColorPub('20')
      }else if(data?.patternPlanStatus === 2212){
        // 型号经理待收样 20
        statusToColorPub('20')
      }
      /**
      let statusList = []
      let mainStatus = data.patternPlanStatus ? data.patternPlanStatus.toString() : null
      let checkStatus = data.checkStatusId ? data.checkStatusId.toString() : null
      let fileStatus = data.selfCheckState ? data.selfCheckState.toString() : null
      let picStatus = data.pictureCheckState ? data.pictureCheckState.toString() : null
      let metadata = ["20","21", "22", "23", "24", "25", "26", "27", "28", "29","31","32", "14", "15", "16"]
      //新品主流程
      // {value: "2217", label: "待分工"},
      // {value: "2218", label: "无标准"},
      // {value: "2216", label: "有标准"},
      // {value: "2238", label: "新品验证中"},
      // {value: "2239", label: "待开发验证"},
      // {value: "2240", label: "开发验证合格"},
      // {value: "2241", label: "开发验证不合格"},
      statusList.push({id: "21", status: "success"})
      if(data.careerConfirmDay){
        statusList.push({id: "20", status: "success"})
      }else{
        statusList.push({id: "20", status: "default"})
      }
      if (mainStatus === "2217") {
        statusList.push({id: "22", status: "warning"})
        return statusList
      } else if(mainStatus === "2239"){
        statusList.push({id: "22", status: "success"})
        statusList.push({id: "23", status: "success"})
        statusList.push({id: "24", status: "success"})
        statusList.push({id: "25", status: "success"})
        statusList.push({id: "26", status: "success"})
        statusList.push({id: "27", status: "success"})
        statusList.push({id: "28", status: "warning"})
      } else if(mainStatus === "2240"){
        statusList.push({id: "22", status: "success"})
        statusList.push({id: "23", status: "success"})
        statusList.push({id: "24", status: "success"})
        statusList.push({id: "25", status: "success"})
        statusList.push({id: "26", status: "success"})
        statusList.push({id: "27", status: "success"})
        statusList.push({id: "28", status: "success"})
      } else if(mainStatus === "2241"){
        statusList.push({id: "22", status: "success"})
        statusList.push({id: "23", status: "success"})
        statusList.push({id: "24", status: "success"})
        statusList.push({id: "25", status: "success"})
        statusList.push({id: "26", status: "success"})
        statusList.push({id: "27", status: "success"})
        statusList.push({id: "28", status: "danger"})
      }else {
        statusList.push({id: "22", status: "success"})
        if (mainStatus === "2218") {
          statusList.push({id: "23", status: "warning"})
          statusList.push({id: "20", status: "default"})
          return statusList
        } else if(mainStatus === "2212"){
          statusList.push({id: "20", status: "warning"})
          statusList.push({id: "23", status: "success"})
        }else{
          statusList.push({id: "23", status: "success"})
        }
      }
      //物料流程
      // {value: "2219", label: "待供方送工厂样"},
      // {value: "2220", label: "待外检收样"},
      // {value: "2221", label: "外检收样打回"},
      // {value: "2222", label: "待型检"},
      // {value: "2223", label: "物料结论待校核"}, 检验待校核
      // {value: "2224", label: "物料结论校核合格"},
      // {value: "2237", label: "物料结论校核不合格"},
      if (checkStatus === "2219") {
        statusList.push({id: "24", status: "warning"})
      } else if(!checkStatus){
        if(mainStatus=='2239' || mainStatus=='2240' || mainStatus=='2241'){

        }else{
          statusList.push({id: "24", status: "default"})
        }
      }else{
        statusList.push({id: "24", status: "success"})
        if (checkStatus === "2220") {
          statusList.push({id: "25", status: "warning"})
        } else if (checkStatus === "2221") {
          statusList.push({id: "25", status: "default"})
          statusList.push({id: "24", status: "danger"})
        } else {
          statusList.push({id: "25", status: "success"})
          if (checkStatus === "2222") {
            statusList.push({id: "26", status: "warning"})
          } else {
            statusList.push({id: "26", status: "success"})
            if (checkStatus === "2223") { // 检验待校核
              statusList.push({id: "27", status: "warning"})
            } else if (checkStatus === "2237") {
              statusList.push({id: "27", status: "danger"})
              if (fileStatus === "2236" || picStatus === '1434') {
                statusList.push({id: "28", status: "warning"})
              }
              if(mainStatus === "2240"){
                statusList.push({id: "28", status: "success"})
              }
              if(mainStatus === '2241'){
                statusList.push({id: "28", status: "danger"})
              }
            } else if(checkStatus == '2502'){ // 2025年1月10日新增 物料打回 物料驳回 物料校核驳回
              statusList.push({id: "27", status: "danger"})
              statusList.push({id: "28", status: "default"})
            } else {
              statusList.push({id: "27", status: "success"})
              if (fileStatus === "2236" || picStatus === '1434') {
                statusList.push({id: "28", status: "warning"})
              }
            }
          }
        }
      }


      //新品文件流程
      // {value: "2226", label: "自检待上传"},
      // {value: "2248", label: "自检待批准"},
      // {value: "2249", label: "自检批准驳回"},
      // {value: "2227", label: "自检待审核"},
      // {value: "2228", label: "自检审核驳回"},
      // {value: "2229", label: "自检待校核"},
      // {value: "2230", label: "自检合格"},
      // {value: "2236", label: "自检不合格"},
      // {value: "2247", label: "有效期内合格"},
      //自检批准
      if (fileStatus === "2226" || fileStatus === "2248") {
        statusList.push({id: "14", status: "warning"})
      } else if (fileStatus === "2249") {
        statusList.push({id: "14", status: "danger"})
      } else if(!fileStatus){
        statusList.push({id: "14", status: "default"})
      } else {
        statusList.push({id: "14", status: "success"})
        //自检审核
        if (fileStatus === "2227") {
          statusList.push({id: "15", status: "warning"})
        } else if (fileStatus === "2228") {
          statusList.push({id: "15", status: "danger"})
        } else {
          statusList.push({id: "15", status: "success"})
          //自检校核
          if (fileStatus === "2229") {
            statusList.push({id: "16", status: "warning"})
          } else if (fileStatus === "2236") {
            statusList.push({id: "16", status: "danger"})
          } else if(fileStatus == "2501"){ // 2025年1月10日新增 自检打回 文件打回 文件驳回 自检校核驳回 
            statusList.push({id: "16", status: "danger"})
          }else {
            console.log('走了这里fileStatus',fileStatus)
            statusList.push({id: "16", status: "success"})
            // statusList.push({id: "24", status: "success"})
          }
        }
      }
      // 制版设计稿流程
      // {value:'1432',label:'待上传'},
      //   {value:'1433',label:'待审核'},
      //   {value:'1434',label:'型号经理审核打回'},
      //   {value:'1435',label:'型号经理审核通过'}
      //   {value:'1836',label:'型号经理审核不合格'}
      if(picStatus){
        if(picStatus === '1432'){
          statusList.push({id: "31", status: "warning"})
        }else{
          statusList.push({id: "31", status: "success"})
          if(picStatus === '1433'){
            statusList.push({id: "32", status: "warning"})
          }else if(picStatus === '1434'){
            statusList.push({id: "32", status: "default"})
            // 新品免检 制版设计稿/模板结果后 开发结论 线段 样式
            if(fileStatus === "2236" || fileStatus === '2230' || fileStatus === '2247'){
              statusList.push({id: "28", status: "warning"})
              if(mainStatus === "2240"){ // 开发结论 合格
                statusList.push({id: "28", status: "success"})
                setTimeout(() => {
                  document.getElementById('line7').style.background = '#009A29'
                  document.getElementById('line8').style.background = '#009A29'
                }, 500);
              }else if(mainStatus === '2241'){ // 开发结论 不合格
                statusList.push({id: "28", status: "danger"})
                setTimeout(() => {
                  document.getElementById('line7').style.background = '#F53F3F'
                  document.getElementById('line8').style.background = '#F53F3F'
                }, 500);
              }else if(mainStatus === '2239'){
                setTimeout(() => { // 待
                  document.getElementById('line7').style.background = '#E6A23C'
                  document.getElementById('line8').style.background = '#E6A23C'
                }, 500);
              }else {
                setTimeout(() => { // 其他
                  document.getElementById('line7').style.background = '#C9CDD4'
                  document.getElementById('line8').style.background = '#C9CDD4'
                }, 500);
              }
            }
          }else if(picStatus === '1435'){
            statusList.push({id: "32", status: "success"})
            // 新品免检 制版设计稿/模板结果后 开发结论 线段 样式
            if(fileStatus === "2236" || fileStatus === '2230' || fileStatus === '2247'){
              statusList.push({id: "28", status: "warning"})
              if(mainStatus === "2240"){ // 开发结论 合格
                statusList.push({id: "28", status: "success"})
                setTimeout(() => {
                  document.getElementById('line7').style.background = '#009A29'
                  document.getElementById('line8').style.background = '#009A29'
                }, 500);
              }else if(mainStatus === '2241'){ // 开发结论 不合格
                statusList.push({id: "28", status: "danger"})
                setTimeout(() => {
                  document.getElementById('line7').style.background = '#F53F3F'
                  document.getElementById('line8').style.background = '#F53F3F'
                }, 500);
              }else if(mainStatus === '2239'){
                setTimeout(() => { // 待
                  document.getElementById('line7').style.background = '#E6A23C'
                  document.getElementById('line8').style.background = '#E6A23C'
                }, 500);
              }else {
                setTimeout(() => { // 其他
                  document.getElementById('line7').style.background = '#C9CDD4'
                  document.getElementById('line8').style.background = '#C9CDD4'
                }, 500);
              }
            }
          }else if( picStatus === '1836'){
            statusList.push({id: "32", status: "danger"})
            statusList.push({id: "28", status: "default"})
          }else{
            statusList.push({id: "32", status: "default"})
            statusList.push({id: "31", status: "default"})
          }
        }
      }

      // 新品模板库流程时 修改主流程样式
      if(this.rowData.isTemplet == 'Y' || this.rowData.checkTypeId === 1105){
        statusList.push({id: "24", status: "default"})
        statusList.push({id: "25", status: "default"})
        statusList.push({id: "26", status: "default"})
        statusList.push({id: "27", status: "default"})
      }

      if (metadata.length !== statusList.length) {
        let list = statusList.map(v => v.id)
        metadata.forEach(v => {
          if (!list.includes(v)) {
            statusList.push({id: v, status: "default"})
          }
        })
      }
 */
      return statusList

    },
    // 关闭流程图
    closeFlow(){
      document.getElementById('line7').style.background = '#EDEFF2'
      document.getElementById('line8').style.background = '#EDEFF2'
      // 重置流程图
      this.flowControlList.forEach(v => {
        this.instanceTemp.update(v.id, 'default')
        this.instanceTemp.review()
      })
      this.flow=false
    },
    // 流程图 结束
    // 模板库
    // 资料库 查看
    lookTempUp(row) {
      this.TempletBtnFlag = false
      this.templetShowFlag = true 
      this.disabledFlag = true
      this.rowData = row
      this.hasTempInfo(row)
      this.postThisPageHeight()
    },
    openTempUp(row) {
      this.TempletBtnFlag = true
      this.templetShowFlag = true 
      this.rowData = row
      if(row.selfCheckState=='2249' ||row.selfCheckState == '2228'){
        this.hasTempInfo(row)
      }else{
        this.getTempInfo(row)
      }
      this.postThisPageHeight()
    },
    // 制版设计稿
    lookPictureUp(row){
      // this.downLoadFile(row.pictureFileId,row.pictureFileName)
      this.$router.push({
        name:'PictureDetail',
        query: {
            patternPlanId:row.patternPlanId,
            data: JSON.stringify(row),
            dataFrom:'sqm'
          }
      })
    },
    openPictureUp(row){
      this.pictureShowFlag = true 
      this.rowData = row
      if(row.pictureFileName){
        // this.tempFile[101]={name:row.pictureFileName}
      }
      this.postThisPageHeight()
    },
    dialogClose() {
      this.pictureShowFlag = false
      this.templetShowFlag = false
      this.rowData = null
      this.tempFile = []
      this.pictureFileId = null
      this.pictureFileName = null
      this.documentList = []
      this.disabledFlag = false
    },
    getTempInfo(row){
      let templetId = row.templetId 
      if(!templetId){
        this.templetShowFlag = false
        // 数据查询错误！
        this.info(h_i18n('a5473898b0523299c9d8b8f715693a6c'))
      }else{
        let thetype = 'T'
        if(row.selfCheckState == '2230' || row.selfCheckState == '2247'){
          thetype = 'Y'
        }else if(row.selfCheckState == '2236'){
          thetype = 'N'
        }
        if(this.TempletBtnFlag){
          this.$http({
            method:'get',
            url:`/base/newProductTemplet/getSqmTempletDocumentBySupplyCode?supplyCode=${this.supplyCode}&templetId=${templetId}`
          }).then(res=>{
            /**
             * 2025年8月1日
             * 200不提示，300和500提示
                200是成功，可以上传文件，可以保存；
                300是成功，不可以上传文件，可以保存；
                500是失败，禁止上传文件和保存；
             */
            if(res.data.code === '200'){
              this.tempFileUp = true
              this.saveBtnDisabled = false
            }else if(res.data.code === '300'){
              this.tempFileUp = false
              this.saveBtnDisabled = false
              res.data.msg && this.info(res.data.msg)
            }else{
              this.tempFileUp = false
              this.saveBtnDisabled = true
              this.info(res.data.msg)
            }
          }).catch(err=>{
            
          }).finally(()=>{
  
          })
        }
        this.templetLoading = true
        this.$http({
        method:'get',
        url:'/base/newProductTemplet/getSqmTempletDocument?templetId='+templetId +'&supplyCode='+this.supplyCode+"&type="+thetype+"&patternPlanId="+row.patternPlanId,
      }).then(res=>{
        if(res.data.code == 200 && res.data.msg == '成功'){
          this.getData = res.data.data
          res.data.data.documentList.forEach((item,index)=>{
            // console.log(item)
            this.documentList.push(item)
            if(item.fileName) {this.tempFile[index]={name:item.fileName}}
          })
        }else{
          this.templetShowFlag = false
          // 数据查询错误！
          this.info(h_i18n('a5473898b0523299c9d8b8f715693a6c'))
        }
      }).catch(err=>{
        this.templetShowFlag = false
        // 数据查询错误！
        this.info(h_i18n('a5473898b0523299c9d8b8f715693a6c'))
        console.log(err)
      }).finally(()=>{
        this.templetLoading = false
      })
      }
    },
    hasTempInfo(row){
      let templetId = row.templetId 
      if(!templetId){
        this.templetShowFlag = false
        // 数据查询错误！
        this.info(h_i18n('a5473898b0523299c9d8b8f715693a6c'))
      }else{
        this.templetLoading = true
        let thetype = 'T'
        if(row.selfCheckState == '2230' || row.selfCheckState == '2247'){
          thetype = 'Y'
        }else if(row.selfCheckState == '2236'){
          thetype = 'N'
        }
        if(this.TempletBtnFlag){
          this.$http({
            method:'get',
            url:`/base/newProductTemplet/getSqmTempletDocumentBySupplyCode?supplyCode=${this.supplyCode}&templetId=${templetId}`
          }).then(res=>{
            /**
             * 2025年8月1日
             * 200不提示，300和500提示
                200是成功，可以上传文件，可以保存；
                300是成功，不可以上传文件，可以保存；
                500是失败，禁止上传文件和保存；
             */
            if(res.data.code === '200'){
              this.tempFileUp = true
              this.saveBtnDisabled = false
            }else if(res.data.code === '300'){
              this.tempFileUp = false
              this.saveBtnDisabled = false
              res.data.msg && this.info(res.data.msg)
            }else{
              this.tempFileUp = false
              this.saveBtnDisabled = true
              this.info(res.data.msg)
            }
          }).catch(err=>{
            
          }).finally(()=>{
  
          })
        }
        this.$http({
        method:'get',
        url:'/base/newProductTemplet/getSqmTempletDocument?templetId='+templetId +'&supplyCode='+this.supplyCode+"&type="+thetype+"&patternPlanId="+row.patternPlanId,
      }).then(res=>{
        if(res.data.code == 200 && res.data.msg == '成功'){
          this.getData = res.data.data
          res.data.data.documentList.forEach((item,index)=>{
            // console.log(item)
            this.documentList.push(item)
            if(item.fileName) {this.tempFile[index]={name:item.fileName}}
          })
        }else{
          this.templetShowFlag = false
          // 数据查询错误！
          this.info(h_i18n('a5473898b0523299c9d8b8f715693a6c'))
        }
      }).catch(err=>{
        this.templetShowFlag = false
        // 数据查询错误！
        this.info(h_i18n('a5473898b0523299c9d8b8f715693a6c'))
        console.log(err)
      }).finally(()=>{
        this.templetLoading = false
      })
      }
    },
    // 附件
    downLoadFile (uuid,name) {
      if(!uuid){
        return
      }
      this.startLoading(h_i18n('29f986479f7cf1f93d31172f343d4521'))
      let url = '/base/fileDownload/downloadFile?filePath=' + uuid
      if(uuid && uuid.includes("http")){
          url = '/base/fileDownload/downloadFile?filePath=mkhl/bukl' + uuid.split('/mkhl/bukl')[1]
      }else if(uuid.includes("mkhl/bukl/")){
          url = '/base/fileDownload/downloadFile?filePath=' + uuid
      }else {
          url = '/base/fileDownload/downloadFile?filePath=hmqm/reject/' + uuid
      }    
      this.httpFile(
        {
          method: 'get',
          url: url,
          headers: { 'content-type': 'application/json' }
        },
        name
      );
    },
    fileUpChange  (options,item,index) {
      let formData = new FormData();
      formData.append('files', options.file);
      this.startLoading(h_i18n('92cd554eff7896f979917f3ae449b460'))
      this.$http({
          method: 'post',
          // url: '/base/fileUpload/uploadToOssSaveUrl',
          url: '/base/fileUpload/uploadToOss',
          headers: { 'Content-Type': 'multipart/form-data' },
          data: formData,
          cache: false,
          processData: false,
          contentType: false
        }).then((res) => {
          if(res.data.code == '0' && res.data.data){
            if(index == 101){
              this.pictureFileId = res.data.data
              this.pictureFileName = options.file.name
            }else{
              item.fileId = res.data.data;
              item.fileName = options.file.name;
            }
          }else{
            this.error(h_i18n('8e2f993840e3108c7f6d8f23d6a8a08d'))
            this.tempFile[index] = null
          }
        }).catch((err) => {
          this.error(h_i18n('8e2f993840e3108c7f6d8f23d6a8a08d'))
          this.tempFile[index] = null
        }).finally(()=>{
          this.closeLoading()
        })
    },
    deleteFile (index,item) {
      this.tempFile[index] = null
      item.fileId = null
      item.fileName = null
      this.pictureFileId = null
      this.pictureFileName = null
    },
    error (str) {
      this.warning({ title: h_i18n('02d9819ddaaaeb1b7b22b12608c7e5ca'), message: str, confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721') });
    },
    saveBtn(){
      if(!this.documentList.every(item=> item.isNeed != 'Y' || item.isNeed == 'Y' && item.fileId && item.fileName)){
        // 有必传项附件未上传！
        this.info(h_i18n('44fa23d8664edf3f7af6178d95cc7c34'))
        return
      }
      // 每次提，documentList中conclusion 应为合格'P'
      this.documentList = this.documentList.map(item=>{
        item.conclusion = 'P'
        return item
      })
      this.saveLoading = true
      this.$http({
        method:'post',
        url:'/base/newProductTemplet/saveSqmTempletDocument',
        data:{
          fixConfig:true,
          supplyCode:this.supplyCode,
          patternPlanId:this.rowData.patternPlanId,
          templetId:this.rowData.templetId,
          documentList:this.documentList,
          submitMan:this.$route.query.trueName || this.$route.query.userName || this.$route.query.nickName
        }
      }).then(res=>{
        if(res.data.code == 200){
          // 成功
          this.success({title:h_i18n('330363dfc524cff2488f2ebde0500896'),message: res.data.msg,
            // 确定
            confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
            callback: () => {
              this.dialogClose()
              this.searchTableList()
            }
          })
        }else{
          this.info(res.data.msg)
        }
      }).catch(err=>{
        this.info(err)
      }).finally(()=>{
        this.saveLoading = false
      })
    },
    saveBtnP(){
      if(!this.pictureFileId || !this.pictureFileName){
        // 制版设计稿未上传！
        this.info(h_i18n('199f4ae28e2c114a0c5368e74d579d5b'))
        return
      }
      this.saveLoading = true
      this.$http({
        method:'post',
        url:'/base/newProductTemplet/insertPictrue',
        data:{
          fixConfig:true,
          pictureFileId:this.pictureFileId,
          pictureFileName:this.pictureFileName,
          patternPlanId:this.rowData.patternPlanId,
          pictureSubmitMan:this.$route.query.trueName || this.$route.query.userName || this.$route.query.nickName,
        }
      }).then(res=>{
        if(res.data.code == 200){
          // 成功
          this.success({title:h_i18n('330363dfc524cff2488f2ebde0500896'),message: res.data.msg,
            // 确定
            confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
            callback: () => {
              this.dialogClose()
              this.searchTableList()
            }
          })
        }else{
          this.warning(res.data.msg)
        }
      }).catch(err=>{
        this.info(err)
      }).finally(()=>{
        this.saveLoading = false
      })
    },
   
    
    conclusionMethod(a, b) {
      if (b === "质量经理") {
        if (a === "P") {
          return <div className="warningColor">提交</div>
        }
      } else {
        if (a === "P") {
          return <div className="successColor">合格</div>
        } else if (a === "F") {
          return <div className="dangerColor">不合格</div>
        } else if (a === "Y") {
          return <div className="successColor">合格</div>
        } else if (a === "N") {
          return <div className="dangerColor">不合格</div>
        } else if (a === "R") {
          return <div className="dangerColor">打回</div>
        } else {
          return <div className="blueColor">未知</div>
        }
      }
    },
    authentication(v) {
      if (v === 1) {//模块提交人
        if (["S003", "S009"].includes(this.roleCode)) {
          return true
        } else {
          // 您不具备权限！请联系质量经理提交
          this.info(h_i18n('a0884977cecc929a114780560daf7de6'))
          return false
        }
      } else if (v === 2) {
        if (["S002", "S006", "S000"].includes(this.roleCode)) {
          return true
        } else {
          // 您不具备权限！请联系质量经理重新提交
          this.info(h_i18n('7037b6ed8fde796eef3c9757e6cad55a'))
          return false
        }
      }
      // if (roleCode === "S003" || roleCode === "S009") {//模块提交人
      // } else if (roleCode === "S002" || roleCode === "S006" || roleCode === "S000") {//模块批准人
      // } else if (roleCode === "S005" || roleCode === "S008") {//模块无权限人
      // } else if (roleCode === "S001" || roleCode === "S004" || roleCode === "S007" || roleCode === "S010") {//模块浏览人
      // } else if (roleCode === "H002" || roleCode === "H011") {//海尔校核人
      // } else {//海尔浏览人
      // }
    },
    lookDetail(row) {
      if(this.multipleSelection.length != 1){
        // 请选择一条数据查看!
        this.info(h_i18n('b63bb501dce4e9d14de36228feef0a0a'))
        return
      }
      if(row.isTemplet=='Y'){
        this.lookTempUp(row)
      }else{
        this.$router.push({
          name: "RepulseSelfInspectionLook",
          query: {
            data: JSON.stringify(row),
            dataFrom:'sqm'
          }
        })
      }
    },
    //查看日志
    lookLog(row) {
      this.drawerLog = true
      this.logLoading = true
      this.logList = []
      //日志 /patternPlan/searchApqpCheckLog
      this.$http({
        method: "get",
        url: "/base/patternPlan/searchApqpCheckLog?patternPlanId=" + row.patternPlanId,
      }).then(async (res) => {
        if (res.data.code === "200") {
          this.logList = res.data.data
        } else {
          // 样简单日志查询失败
          this.info(`${row.patternPlanId}${h_i18n('a049665892467b0b048c8ac659438838')}`)
        }
        this.logLoading = false
      }).catch((err) => {
        this.logLoading = false
      });
    },
    deliveryTypeChange(c) {
      if (c === "自送") {
        this.sampleDelivery.deliveryNo = ""
      }
    },

    // 拖期原因选择
    sendSampleDelayReasonChoose (){
      if(!this.sampleDelivery.sendSampleDelayReason){
        this.sampleDelivery.sendSampleDelayReasonRemark = undefined
      }else{
        if(this.sampleDelivery.sendSampleDelayReason === 2140860443){
          this.sendSampleDelayReasonRemarkShow = true
        }else{
          this.sampleDelivery.sendSampleDelayReasonRemark = undefined
          this.sendSampleDelayReasonRemarkShow = false
        }
      }
    },
    // 清空拖期相关字段
    clearsendSampleDelayReason(){
      this.sampleDelivery.sendSampleDelayReason = null
      this.sendSampleDelayReasonShow = false
      this.sampleDelivery.sendSampleDelayReasonRemark = null
      this.sendSampleDelayReasonRemarkShow = false
    },
    //样检单列表 送样抽屉
    checkStatusM(row) {
      if(!row.checkStatusId){
        // 请选择待送工厂样或收样驳回的数据进行操作！
        this.info(h_i18n('92b25dcbfe70f7780600c92802ffa488'))
        return false
      }
      if (row.checkStatusId === 2219) {
        //代工厂送样
        if (!["S003", "S009"].includes(this.roleCode)) {
          // 您不具备权限！
          this.info(h_i18n('4e529cf79d56c438f1d62ff9e3d12377'))
          return false
        }
        this.status = 1
      } else if (row.checkStatusId === 2221) {
        //送样驳回
        if (!["S003", "S009"].includes(this.roleCode)) {
          // 您不具备权限！
          this.info(h_i18n('4e529cf79d56c438f1d62ff9e3d12377'))
          return false
        }
        this.status = 3
      } else {
        //已送样
        this.status = 2
        this.sampleDelivery.supplySendSampleDate = row.supplySendSampleDate
        this.sampleDelivery.deliveryType = row.deliveryType
        this.sampleDelivery.sqeAffirmDate = row.sqeAffirmDate
        this.sampleDelivery.sqeAffirmMark = row.sqeAffirmMark
        // 拖期的判断及显示 如果是 查看 如果有拖期字段就显示拖期 
        if(row.sendSampleDelayReason){
          this.sampleDelivery.sendSampleDelayReason = row.sendSampleDelayReason
          this.sendSampleDelayReasonShow = true
        }
        if(row.sendSampleDelayReasonRemark){
          this.sampleDelivery.sendSampleDelayReasonRemark = row.sendSampleDelayReasonRemark
          this.sendSampleDelayReasonRemarkShow = true
        }
      }

      /* 
      {value: "2219", label: "待供方送工厂样"},
        {value: "2220", label: "待外检收样"},
        {value: "2221", label: "外检收样打回"},
        {value: "2222", label: "待型检"},
        {value: "2223", label: "物料结论待校核"},
        {value: "2224", label: "物料结论校核合格"},
        {value: "2237", label: "物料结论校核不合格"},
       */
      
      // 判断是否拖期送样 如果是操作送样 根据时间判断
      
      let nowDate = new Date().getTime()
      // 应送样时间 只取年月日
      let supplierSendFactorySamplePlanDate = this.time(row.supplierSendFactorySamplePlanDate,3)
      // 加上时分秒
      supplierSendFactorySamplePlanDate += ' 23:59:59'
      // 时间戳
      supplierSendFactorySamplePlanDate = new Date(supplierSendFactorySamplePlanDate).getTime()
      
      if(this.status !== 2 && nowDate > supplierSendFactorySamplePlanDate){
        console.log('拖期了！！！！！！！！！！！！！')
        this.sendSampleDelayReasonShow = true
      }

      if (row.checkStatusId === 2220 || row.checkStatusId === 2221) {
        this.sampleDelivery.supplySendSampleDate = row.supplySendSampleDate
        this.sampleDelivery.deliveryType = row.deliveryType
        this.sampleDelivery.sqeAffirmDate = row.sqeAffirmDate
        this.sampleDelivery.sqeAffirmMark = row.sqeAffirmMark
        this.sampleDelivery.supplierSendFactorySamplePlanDate = this.time(row.supplierSendFactorySamplePlanDate, 3)
      } else {
        // this.sampleDelivery.supplySendSampleDate = this.time(row.supplierSendFactorySamplePlanDate, 6)//supplierSendFactorySamplePlanDate
        this.sampleDelivery.supplierSendFactorySamplePlanDate = this.time(row.supplierSendFactorySamplePlanDate, 3)//supplierSendFactorySamplePlanDate
        // 快递
        this.sampleDelivery.deliveryType = row.deliveryType || h_i18n('705d54db81f6eaf23b9c56eb0b4b40d4')
      }
      this.drawer = true
      this.sampleDelivery.patternPlanId = row.patternPlanId
      this.sampleDelivery.supplySendSampleMan = row.supplySendSampleMan
      this.sampleDelivery.supplySendSampleNumber = row.supplySendSampleNumber
      this.sampleDelivery.deliveryNo = row.deliveryNo
      this.sampleDelivery.planDeliveryDate = row.planDeliveryDate
      this.sampleDelivery.mtlNo = row.mtlNo
      this.sampleDelivery.supplyCode = row.supplyCode
      if (row.samplePicture) {
        this.fileListOld = row.samplePicture.split(",").map(v => {
          let l = v.split("£™£")
          return {
            filePath: l[0],
            fileName: l[1]
          }
        })
      } else {
        this.fileListOld = []
      }
    },
    planDeliveryDateTime(b) {
      b.planDeliveryDate = this.time(b.planDeliveryDate, 3)
    },
    //样检单提交前的校验
    beforeSampleDeliverySubmit() {
      let obj = {
        // 供方送样人
        supplySendSampleMan: h_i18n('6a52ae8d38d65d94a9673129041ca156'),
        // 供方送样数量
        supplySendSampleNumber: h_i18n('0a5b1df588a1e061097183d52c2d585b'),
        // 预计送样时间
        planDeliveryDate: h_i18n('5ad67a9e2faec80e40f03e924c59dc43'),
      }
      if(this.sendSampleDelayReasonShow){
        // 送样拖期原因
        obj.sendSampleDelayReason = h_i18n('01A3AD4C38FDCDB333EF79759E011F67')
      }
      if(this.sendSampleDelayReasonRemarkShow){
        // 送样拖期其它原因说明
        obj.sendSampleDelayReasonRemark = h_i18n('D5D682769E2FD411333DB100B9A6AD3E')
      }
      let list = Object.keys(obj)
      try {
        for (let i = 0; i < list.length; i++) {
          if (this.sampleDelivery[list[i]] === "" || !this.sampleDelivery[list[i]] || /^\s+$/.test(this.sampleDelivery[list[i]])) {
            // '不允许为空
            this.info(`'${obj[list[i]]}${h_i18n('cbbb150bd58f9e91ae9c27dc45b40daa')}`)
            throw new Error()
          }
        }
      } catch (e) {
        return false
      }
      if (this.sampleDelivery["deliveryType"] === "快递") {
        if (this.sampleDelivery.deliveryNo === "" || !this.sampleDelivery.deliveryNo) {
          // '快递单号'不允许为空
          this.info(h_i18n('f46acd2184c364d2d920fdda392ae4ad'))
          return false
        }
      }
      if (this.fileListOld.length < 2) {
        // 请至少上传两张送样样件照片
        this.info(h_i18n('e59dff3a1da309948ada1d83a0b44cef'))
        return false
      }

      return true


    },
    //样检单提交
    sampleDeliverySubmit() {
      if (!this.beforeSampleDeliverySubmit()) return false
      let str = this.fileListOld.map(v => (`${v.filePath}£™£${v.fileName}`)).join(",")
      this.sampleDeliveryLoading = true
      this.$http({
        method: "post",
        url: "/base/patternPlan/sendFactorySample",
        data: {
          ...this.sampleDelivery,
          samplePicture: str,
          userId: this.$route.query.name,
          supplierSendFactorySamplePlanDate:undefined,
        },
      }).then(async (res) => {
        if (res.data.code === "200") {
          // 送样成功
          this.success(h_i18n('e71a11c45ba66452589198143db14727'))
          this.paginationQuery(1)
          this.drawer = false
          // 清空拖期相关字段
          this.clearsendSampleDelayReason()
        } else {
          this.error(res.data.msg)
        }
        this.sampleDeliveryLoading = false
      }).catch((err) => {
        this.sampleDeliveryLoading = false
      });
    },
    init() {
      this.sampleDelivery.supplySendSampleDate = this.time(new Date(), 6)
      this.roleCode = this.$route.query.roleCode
    },
    openImg(item) {
      window.open(item)
    },
    lookPicture() {
      this.pictureL = true
      this.pictureList = this.fileListOld.map(v => v.filePath)
    },
    //打开面板
    openPlan() {
      this.fileList = []
      this.fileUploadM = true
      this.fileList = this.fileListOld.map((v, i) => ({...v, status: "success", progress: 100, name: v.fileName})).filter(v => v.fileName)
    },
    //选择文件
    chooseFile(file, fileList) {
      this.fileList = fileList
    },
    errorFile(str) {
      this.info(str)
    },

    //删除文件
    removeFile(file) {
      this.fileList = this.fileList.filter(v => v.uid !== file.uid)
    },
    //文件上传
    uploadFile() {
      let uploadFileList = this.fileList.filter(v => v.status === "default")
      if (uploadFileList.length === 0) {
        if (this.fileListOld.length !== this.fileList.length) {
          this.fileListOld = this.fileList.map(v => ({fileName: v.name, filePath: v.filePath}))
          this.fileUploadM = false
          return false
        }
        // 请选择文件
        this.info(h_i18n('9febf31146d9c96bfde09a4a20dcf17d'))
        return false
      }
      let formData = new FormData()
      uploadFileList.map(v => {
        formData.append('files', v.file)
        v.progress = 50
      })
      return this.$http({
        method: 'post',
        url: '/base/fileUpload/uploadToOssSaveUrl',
        headers: {'Content-Type': 'multipart/form-data'},
        data: formData,
        cache: false,
        processData: false,
        contentType: false,
      }).then((res) => {
        if (res.data.code === "0") {
          let data = res.data.data
          let noList = this.fileList.filter(v => !v.filePath)
          let hasList = this.fileList.filter(v => v.filePath)
          this.fileListOld = [...hasList.map(v => {
            return {
              fileName: v.name,
              filePath: v.filePath
            }

          }), ...data.split(",").map((v, i) => {
            return {
              fileName: noList[i] ? noList[i].name : `computer${this.time()}`,
              filePath: v
            }
          })]
          uploadFileList.map(v => {
            v.progress = 100
            v.status = "success"
          })
          this.success({
            // 提示
            title: h_i18n('02d9819ddaaaeb1b7b22b12608c7e5ca'),
            // 上传成功
            message: h_i18n('a7699ba73144aad544eb9ac49f82749d'),
            // 确定
            confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
            // 取消
            cancelButtonText: h_i18n('625fb26b4b3340f7872b411f401e754c'),
            callback: (action) => {
              this.fileUploadM = false
            }
          })
          console.log(this.fileListOld)
        } else {
          return Promise.reject()
        }
      }).catch((err) => {
        uploadFileList.map(v => {
          v.progress = 100
          v.status = "fail"
        })
        // 上传失败
        this.error(h_i18n('54e5de428ca9d59119d4624706215a4d'))
      });
    },
    patternPlanStatusRender(row) {
      //新品状态
      if (!row.patternPlanStatus) return "-"
      let a = this.fileNewStatus.filter(v => v.value == row.patternPlanStatus.toString())[0]
      if (!a) return "-"
      return a.label

      // switch (row.patternPlanStatus) {
      //   case 2212:
      //     return "型号经理待收样"
      //   case 2217:
      //     return "待分工状态"
      //   case 2218:
      //     return "无标准"
      //   case 2238:
      //     return "新品验证中"
      //   case 2239:
      //     return "待开发验证"
      //   case 2240:
      //     return "开发验证合格"
      //   case 2241:
      //     return "开发验证不合格"
      // }
    },
    mouseEnter(row) {
      clearTimeout(row.configTimeout)
      row.config = true
    },
    mouseLeave(row) {
      row.configTimeout = setTimeout(() => {
        row.config = false
      }, 300)
    },
    mouseLeaveNow(row) {
      row.config = false
    },
    inspectionMethodRender(id) {
      if (!id) return
      let a = this.inspectionMethod.filter(v => v.value == id.toString())[0]
      if (!a) return "-"
      let b, c
      if (a) {
        switch (a.value) {
          case 1104:
            b = "warningColor";
            // 新品标准检
            c = h_i18n('07776c59765079b72e7b52cf69d7724c')
            break
          case 1105:
            b = "successColor";
            // 新品免检
            c = h_i18n('860c31139e636c2fc05e6dc5faf071bf')
            break
          case 1106:
            b = "blueColor";
            // 新品加速检
            c = h_i18n('aaedacb2e922bd7a5b98f05e4e6c06f6')
            break
          case 1141:
            b = "dangerColor";
            // 新品停检
            c = h_i18n('6af02ad416e5589fcc3fcb9e89d30e31')
            break
          default:
            b = ""
            c = "-"
        }
      }
      return `<div class="${b}">${c}</div>`
    },
    fileCheckPictureStatus(data){
      if (!data) return "-"
      let a = this.pictureStatus.filter(v => v.value == data.toString())[0]
      if (!a) return "-"
      return a.label
    },
    materielCategoryFormatter(data) {
      if (!data) return "-"
      let a = this.materielCategoryNameList.filter(v => v.materielCategoryId.toString() === data.toString())[0]
      if (!a) return "-"
      return a.materielCategoryName
    },
    listCheckBoxChange(val) {
      this.multipleSelection = val;
    },
    changeMethod() {
      this.postThisPageHeight()
    },
    derive() {
      if (this.pageNation.total > 5000) {
        this.info({
          // 提示
          title: h_i18n('02d9819ddaaaeb1b7b22b12608c7e5ca'),
          // 导出数量大于5000条
          message: h_i18n('748c802d8fe36ada78520df791295747'),
          // 确定
          confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
        })
      } else {
        this.loading.exportLoading = true
        this.$http({
          method: "post",
          url: "/base/patternPlan/exportListSqm",
          data: {
            ...this.searchData,
            userId: this.$route.query.name,
            userName: this.$route.query.nickName,
            userId : "SUPPLY",
            supplyCode : this.$route.query.name,
          },
          responseType: "blob",
        }).then(async (res) => {
          if (res.status === 200) {
            try {
              let blobText = new Blob([res.data], {
                type: "application/json",
              }); // 文件流
              let response = JSON.parse(await blobText.text())
              if (response.success === false) {
                this.loading.exportLoading = false
                this.error(response.msg)
              }
            } catch (e) {
              let blob = new Blob([res.data], {
                type: "application/vnd.ms-excel",
              }); // 文件流
              let blobUrl = URL.createObjectURL(blob);
              const link = document.createElement("a"); //模拟a链接，不支持低版本ie
              // 新品检验.xlsx
              link.download = h_i18n('2fe09c5e2f9b6c10edafe92ac54d263c');
              link.style.display = "none";
              link.href = blobUrl;
              document.body.appendChild(link);
              link.click();
              URL.revokeObjectURL(link.href);
              document.body.removeChild(link);
              this.loading.exportLoading = false
            }
          }
        }).catch((err) => {
          this.loading.exportLoading = false
        });
      }
    },
    formDate(val, len = 3) {
      if (val) {
        return this.time(val, len)
      } else {
        return "-"
      }
    },
    dateMapChange(item, value) {
      this.searchData[item + "Start"] = (value ? this.time(value[0], 3) : "")
      this.searchData[item + "End"] = (value ? this.time(value[1], 3) : "")
    },
    paginationQuery(val) {
      this.pageNation.pageIndex = val;
      if (this.http.searchHttp) {
        this.http.searchHttp.cancel()
        this.http.searchHttp = null
        this.loading.tableListLoading = false;
      }
      this.searchTableList();
    },
    searchTableList() {
      this.http.searchHttp = axios.CancelToken.source();
      this.loading.tableListLoading = true
      if (!this.searchData.warehouseCode) {
        delete this.searchData.warehouseCode
      }
      this.tableDataList = [];
      let params = {...this.searchData};
      params.userId = "SUPPLY";
      params.supplyCode = this.$route.query.name;
      return this.$http({
        method: "post",
        url: "/base/patternPlan/listPage",
        data: {
          ...this.pageNation,
          ...params,
          patternPlanStatus:params.patternPlanStatus.length > 0 ? params.patternPlanStatus : undefined,
          pictureCheckState:params.pictureCheckState.length > 0 ? params.pictureCheckState : undefined,
          selfCheckState:params.selfCheckState.length > 0 ? params.selfCheckState : undefined,
          checkStatusId:params.checkStatusId.length > 0 ? params.checkStatusId : undefined,
          selfDelayReason:params.selfDelayReason.length > 0 ? params.selfDelayReason : undefined,
          sendSampleDelayReason:params.sendSampleDelayReason.length > 0 ? params.sendSampleDelayReason : undefined,
        },
        cancelToken: this.http.searchHttp.token,
      }).then((res) => {
        this.loading.tableListLoading = false;
        if (res.data.code === "200") {
          if (res.data.data.records) {
            this.tableDataList = res.data.data.records.map(v => ({...v, loading: false, config: false}));
            this.pageNation.total = res.data.data.total;
          } else {
            this.tableDataList = [];
            this.pageNation.total = 0;
          }
        }
      }).catch((err) => {
        this.loading.tableListLoading = false;
        console.log(err.toString())
        if (err.toString() !== "Cancel") {
          // 查询失败
          this.error(h_i18n('0d66ed02d74d0bd89431d6d59533ffb3') + err)
        }
      });
    },
    lookPatternPlan(a) {
      // 样检单无效
      if (!a) this.warning(h_i18n('7463152c99c30e6ea8ff42196256ab57'))
      this.$router.push('/SampleInspectionFormLook?patternPlanId=' + a)
    },

    upload(type, row) {
      if (type === "upload" || type === "upload-b") {
        if(type === "upload" && row.isTemplet=='Y'){
          this.openTempUp(row)
        }else
        if (type === "upload") {
          if (this.authentication(1)) {
            this.$router.push({
              name: "UploadSelfInspectionData",
              query: {
                name: this.$route.query.name,
                nickName: this.$route.query.nickName,
                ...this.$route.query,
                formType: type,
                data: JSON.stringify(row),
                dataFrom:'sqm',
              },
            })
          }
        } else {
          if (this.authentication(2)) {
            this.$router.push({
              name: "UploadSelfInspectionData",
              query: {
                name: this.$route.query.name,
                nickName: this.$route.query.nickName,
                ...this.$route.query,
                formType: type,
                data: JSON.stringify(row),
                dataFrom:'sqm',
              },
            })
          }
        }
      } else if (type === "repulse" || type === "repulse-b") {
        if(row.isTemplet=='Y'){
          this.openTempUp(row)
        }else
        if (this.authentication(1)) {
          this.$router.push({
            name: "RepulseSelfInspectionData",
            query: {
              name: this.$route.query.name,
              nickName: this.$route.query.nickName,
              ...this.$route.query,
              formType: type,
              data: JSON.stringify(row),
            },
          });
        }
      }
    },


    /**
     * 处理两个查询
     * *******************************************************************************
     */
    myBlur(v) {
      if (!this.planBlur) {
        this.plan[v] = false;
      }
    },
    myFocus3(v) {
      this.planBlur = false
      if (this.searchData.mtlNo.length >= 4) {
        this.plan[v] = true;
      }
    },
    // 供应商获取焦点
    myFocus4(v) {
      this.planBlur = false;
      if (this.searchData.supplyCode.length >= 2) {
        this.plan[v] = true;
      }
    },
    /**
     * 专用号模糊查询
     */
    mtlNoChange() {
      this.planBlur = false;
      if (this.http.mtlSearchHttp) this.http.mtlSearchHttp.cancel()
      this.http.mtlSearchHttp = axios.CancelToken.source()
      if (this.searchData.mtlNo.length < 4) {
        this.plan.showMtlPlan = false;
      } else {
        this.loading.mtlLoading = true;
        this.plan.showMtlPlan = true;
        this.$http({
          method: "POST",
          url: "/base/basicData/searchMaterielList",
          headers: {"content-type": "application/json"},
          data: {
            mtlNo: this.searchData.mtlNo,
          },
          cancelToken: this.http.mtlSearchHttp.token
        }).then((res) => {
          this.mtlNoList = res.data.data;
          this.loading.mtlLoading = false;
        }).catch(e => {
        });
      }
    },
    clickMtlNo(row) {
      this.searchData.mtlNo = row.mtlNo;
      this.plan.showMtlPlan = false;
    },


    /**
     * 获取工厂小微
     */
    getSybList() {
      this.$http({
        method: "get",
         url: "/base/OqcA/listSyb",
      }).then((res) => {
        this.sybList = res.data.map(item=>{
          return {valueName: item.departmentName,valueId: item.departmentId}
        })
      });
    },
    /**
     * 获取物料大类
     */
    getMtlList() {
      this.$http({
        method: "get",
        url: "/base/common/getMaterielCategoryList",
      }).then((res) => {
        this.materielCategoryNameList = res.data.data
      });
    },
    // 样检单 
    // 查看
    detailPatternPlanBtn(){
      if(this.multipleSelection.length != 1){
        // 请选择一条数据查看!
        this.info(h_i18n('b63bb501dce4e9d14de36228feef0a0a'))
        return
      }
      this.$router.push('/SampleInspectionFormLook?patternPlanId=' + this.multipleSelection[0].patternPlanId + "&dataFrom=sqm")
    },
    // 自检报告
    // 查看
    detailSelfInspectionBtn(){
      if(this.multipleSelection.length != 1){
        // 请选择一条数据查看!
        this.info(h_i18n('b63bb501dce4e9d14de36228feef0a0a'))
        return
      }
      if(this.multipleSelection[0].isTemplet=='Y'){
        this.lookTempUp(this.multipleSelection[0])
      }else{
        this.$router.push({
          name: "RepulseSelfInspectionLook",
          query: {
            data: JSON.stringify(this.multipleSelection[0]),
            dataFrom:'sqm'
          }
        })
      }
    },
    // 自检上传
    upSelfInfpectionBtn(){
      if(this.multipleSelection.length != 1){
        // 请选择一条数据进行自检上传!
        this.info(h_i18n('c1a2bf463dcd58ae2b5032ef458170ee'))
        return
      }
      if(this.multipleSelection[0].selfCheckState===2226){
        this.upload('upload',this.multipleSelection[0])
      }else if(this.multipleSelection[0].selfCheckState===2228){
        this.upload('repulse',this.multipleSelection[0])
      }else if(this.multipleSelection[0].selfCheckState===2249){
        this.upload('repulse-b',this.multipleSelection[0])
      }else {
        // 请选择自检待上传、自检审核驳回、自检批准驳回的数据进行自检上传！
        this.info(h_i18n('dfd80837bde1624c811df27b978624bb'))
      }
    },
    // 自检批准
    auSelfInfpectionBtn(){
      if(this.multipleSelection.length != 1){
        // 请选择一条数据进行自检批准!
        this.info(h_i18n('a4bada44a9c408d4ca8bc1c048218d6a'))
        return
      }
      if(this.multipleSelection[0].selfCheckState!==2248){
        // 请选择自检待批准进行自检批准！
        this.info(h_i18n('e3993a0db14e060546e460e0d7a0d243'))
      }else{
        this.upload('upload-b',this.multipleSelection[0])
      }
    },
    // 检测报告
    // 查看
    detailTestReportBtn(){
      if(this.multipleSelection.length != 1){
        // 请选择一条数据查看!
        this.info(h_i18n('b63bb501dce4e9d14de36228feef0a0a'))
        return
      }
      this.$router.push({
        name: "NewProductInspectionTask/InspectionPlanView",
        query: {
          name: this.$route.query.name,
          nickName: this.$route.query.nickName,
          data: JSON.stringify(this.multipleSelection[0]),
          dataFrom:'sqm'
        },
      });
    },
    // 制版设计稿 
    // 查看
    detailPictureBtn(){
      if(this.multipleSelection.length != 1){
        // 请选择一条数据查看!
        this.info(h_i18n('b63bb501dce4e9d14de36228feef0a0a'))
        return
      }
      if(!this.multipleSelection[0].pictureFileId){
        // 暂无制版设计稿数据！
        this.info(h_i18n('fbddd51d87a9b798193bda360b4ef671'))
      }else{
        this.lookPictureUp(this.multipleSelection[0])
      }
    },
    upPictureBtn(){
      if(this.multipleSelection.length != 1){
        // 请选择一条数据上传制版设计稿!
        this.info(h_i18n('73a6033da13e5c531a4a0bbc78e8678d'))
        return
      }
      if(this.multipleSelection[0].isTemplet != 'Y'){
        // 请选择新品免检的数据进行制版设计稿上传!
        this.info(h_i18n('b4e18d6e679381f05e9825da33bc8860'))
        return
      }
      if(this.multipleSelection[0].pictureCheckState == '1432' || this.multipleSelection[0].pictureCheckState=='1434'){
        this.openPictureUp(this.multipleSelection[0])
      }else{
        // 请勿重复上传制版设计稿!
        this.info(h_i18n('0ad2500c989bddf84cb11d9daba2412e'))
      }
    },
    // 送样
    sendSampleBtn () {
      if(this.multipleSelection.length != 1){
        // 请选择一条数据送样!
        this.info(h_i18n('2ee8586bacb0d0b29fcd45c0288c5f43'))
        return
      }
      if(this.multipleSelection[0].checkStatusId != 2219 && this.multipleSelection[0].checkStatusId != 2221){
        // 请选择待送工厂样或收样驳回的数据进行操作！
        this.info(h_i18n('92b25dcbfe70f7780600c92802ffa488'))
        return false
      }
      this.checkStatusM(this.multipleSelection[0]) 
    },
    // 查看送样
    detailSampleBtn () {
      if(this.multipleSelection.length != 1){
        // 请选择一条数据送样!
        this.info(h_i18n('2ee8586bacb0d0b29fcd45c0288c5f43'))
        return
      }
      let row = this.multipleSelection[0]
      if(!row.checkStatusId){
        // 暂无送样数据！
        this.info(h_i18n('a72197fb103f478c2836146341851806'))
        return false
      }
      this.status = 2
        this.sampleDelivery.supplySendSampleDate = row.supplySendSampleDate
        this.sampleDelivery.deliveryType = row.deliveryType
        this.sampleDelivery.sqeAffirmDate = row.sqeAffirmDate
        this.sampleDelivery.sqeAffirmMark = row.sqeAffirmMark
        if (row.checkStatusId === 2220 || row.checkStatusId === 2221) {
        this.sampleDelivery.supplySendSampleDate = row.supplySendSampleDate
        this.sampleDelivery.deliveryType = row.deliveryType
        this.sampleDelivery.sqeAffirmDate = row.sqeAffirmDate
        this.sampleDelivery.sqeAffirmMark = row.sqeAffirmMark
        this.sampleDelivery.supplierSendFactorySamplePlanDate = this.time(row.supplierSendFactorySamplePlanDate, 3)
      } else {
        // this.sampleDelivery.supplySendSampleDate = this.time(row.supplierSendFactorySamplePlanDate, 6)//supplierSendFactorySamplePlanDate
        this.sampleDelivery.supplierSendFactorySamplePlanDate = this.time(row.supplierSendFactorySamplePlanDate, 3)//supplierSendFactorySamplePlanDate
        // 快递
        this.sampleDelivery.deliveryType = row.deliveryType || h_i18n('705d54db81f6eaf23b9c56eb0b4b40d4')
      }
      this.drawer = true
      // 拖期的判断及显示 如果是 查看 如果有拖期字段就显示拖期 
      if(row.sendSampleDelayReason){
        this.sampleDelivery.sendSampleDelayReason = row.sendSampleDelayReason
        this.sendSampleDelayReasonShow = true
      }
      if(row.sendSampleDelayReasonRemark){
        this.sampleDelivery.sendSampleDelayReasonRemark = row.sendSampleDelayReasonRemark
        this.sendSampleDelayReasonRemarkShow = true
      }
      this.sampleDelivery.patternPlanId = row.patternPlanId
      this.sampleDelivery.supplySendSampleMan = row.supplySendSampleMan
      this.sampleDelivery.supplySendSampleNumber = row.supplySendSampleNumber
      this.sampleDelivery.deliveryNo = row.deliveryNo
      this.sampleDelivery.planDeliveryDate = row.planDeliveryDate
      this.sampleDelivery.mtlNo = row.mtlNo
      this.sampleDelivery.supplyCode = row.supplyCode
      if (row.samplePicture) {
        this.fileListOld = row.samplePicture.split(",").map(v => {
          let l = v.split("£™£")
          return {
            filePath: l[0],
            fileName: l[1]
          }
        })
      } else {
        this.fileListOld = []
      }
    },
    // 送样图片
    // 处理图片链接
    typePicture(list){
      if (list) {
        return list.split(",").map(v => {
          let l = v.split("£™£")
          return {
            filePath: l[0],
            fileName: l[1]
          }
        })
      }
      console.log('typePicture',typePicture)
    },
    // 送样历史查询
    sampleLog(patternPlanId){
      let obj = {
        patternPlanId: patternPlanId,
        pageNo: 1,
        pageSize: 99,
      }
      this.$http({
        url:'/base/sendSampleLog/listPage',
        method:'post',
        data:obj
      }).then(res=>{
        if(res.data.code === '200'){
          if(res.data?.data?.records.length > 0){
            this.historyTable = res.data.data.records
            this.historyShow = true
          }else{
            // 暂无；送样；历史
            this.warning(h_i18n('f61f4cf6d0d544fad4507868b74696a1')+(h_i18n('480314fec74c7ad31c65e15658d015fa') + h_i18n('c827d8dbb76ce33219f64c6749893159')))
            this.historyTable = []
            this.historyShow = false
          }
        } else {
          this.warning(res.data?.msg)
          this.historyTable = []
          this.historyShow = false
        }
      }).catch(err=>{
        console.log(err)
      }).finally(()=>{
        this.historyLoading = false
      })
    },
    // 关闭送样历史
    historyCancel(){
      this.historyShow = false
      this.historyTable = []
    },
    // 送样拖期原因名
   resonName (id) {
    return this.sendSampleDelayReasonData.find(item=>{
      return item.value === id
    })?.label
  },
    // 查询是否模板库供应商
    getTempletSupply(){
      // this.$http({
      //   url:'/base/basicData/baseValuesById?valueId=2209',
      //   method:'get'
      // }).then(res=>{
      //   console.log(res)
      //   if(res.data.data.reamrk && res.data.data.reamrk.length > 0){
      //       this.supplyList = res.data.data.reamrk
      //       this.templetFlag = this.supplyList.includes(this.supplyCode.toUpperCase())
      //     }
      // }).catch(err=>{})
      this.$http({
        method:'post',
        url:'/base/patternPlan/templateSupplierList',
        data:{
          pageNo:1,
          pageSize:9999,
        }
      }).then(res=>{
        if(res.data.code == '200' && res.data.data && res.data.data.records){
          this.supplyList = res.data.data.records.map(item=>{
            return item.supplyCode
          })
          this.templetFlag = this.supplyList.includes(this.supplyCode.toUpperCase())
        }
      }).catch(err=>{
      }).finally(()=>{
      })
    },
    // 查询状态表
    getBaseValues(){
      this.$http({
        method: "post",
        url: "/base/basicData/listBaseValuesByIds",
        data: [92,22,94,78,91,112],
      }).then((res) => {
        if (res.data.code === "200") {
          res.data.data.forEach(item=>{
            if(item.valueTypeId == 92){
              this.fileStatus.push({value:item.valueId,label:item.valueName})
            }
            if(item.valueTypeId == 22){
              this.inspectionMethod.push({value:item.valueId,label:item.valueName})
            }
            if(item.valueTypeId == 94){
              this.materialStatus.push({value:item.valueId,label:item.valueName})
            }
            if(item.valueTypeId == 78){
              this.pictureStatus.push({value:item.valueId,label:item.valueName})
            }
            if(item.valueTypeId == 91){
              this.fileNewStatus.push({value:item.valueId,label:item.valueName})
            }
            // 拖期原因走配置表
            if(item.valueTypeId === 112){
              this.sendSampleDelayReasonData.push({value:item.valueId,label:item.valueName})
              this.selfDelayReasonData.push({value:item.valueId,label:item.valueName})
            }
          })
        } else {
        }
      }).catch((err) => {
      });
    },
  },
  mounted() {
    //四季菜单
    if (this.$route.query.roleCode) {
      this.roleCode = this.$route.query.roleCode;
    }
    if (this.$route.query.supplyCode) {
      this.supplyCode = this.$route.query.supplyCode;
    }
    if (this.$route.query.dataFrom) {
      this.dataFrom = this.$route.query.dataFrom;
    }
    this.name = this.$route.query.name
    if (this.$route.query.name || this.$route.query.nickName) {
      // localStorage.setItem("name",this.$route.query.name);
      // localStorage.setItem("nickName",this.$route.query.nickName)
      window.getItemName = this.$route.query.name;
      window.getItemNickName = this.$route.query.nickName;
    }
    this.init()
    this.getSybList(); // 获取工厂
    this.getMtlList(); // 获取物料
    this.postThisPageHeight()
    this.flowSchedule()
    this.getTempletSupply() // 获取模板库供应商
    this.getBaseValues()
    if(this.$route.query.parentId && this.$route.query.parentId != 'null' && this.$route.query.parentId != 'undefined' && this.$route.query.parentId != ''){
    let p = this.getButtonFromSqm(this.$route.query.parentId,this.$route.query.roleCode)
    p.then(res=>{
      if(res.length > 0){
        this.btnListOfSqm = res
      }
    })
  }else{
    this.btnListOfSqm = [
      // 送样
      {code:'mkhl_xxpjyjh_SYCK',name:h_i18n('480314fec74c7ad31c65e15658d015fa')},
      // 样检单
      {code:'mkhl_xxpjyjh_YJD',name:h_i18n('9bc00dfcaffa57bf6a9b324b02e8a3b3')},
      // 自检报告
      {code:'mkhl_xxpjyjh_ZJBG',name:h_i18n('497c8434bc60bc8e338faea5d44a6b6d')},
      // 制版设计稿查看
      {code:'mkhl_xxpjyjh_ZBSJG',name:h_i18n('ef56762cdbe4eb9317ad296787abfb2a')},
      // 检测报告
      {code:'mkhl_xxpjyjh_JCBG',name:h_i18n('23ec39309965464235d52dc8d3769714')},
      // 送样
      {code:'mkhl_xxpjyjh_SONGYANG',name:h_i18n('480314fec74c7ad31c65e15658d015fa')},
      // 自检上传
      {code:'mkhl_xxpjyjh_ZJSC',name:h_i18n('10a54b7cfc3ee0b8120adc93e8a76052')},
      // 自检批准
      {code:'mkhl_xxpjyjh_ZJPZ',name:h_i18n('145b2c31081ad6d14147640003961c6f')},
      // 制版设计稿上传
      {code:'mkhl_xxpjyjh_ZBSJGSC',name:h_i18n('65d2b4cc69ee0d7fa8706a074b5b2b39')},
      // 导出
      {code:'mkhl_xxpjyjh_DC',name:h_i18n('55405ea6ff6fd823ffab7e6b10ddfa95')},
    ]
  }
  },
  activated() {
    this.paginationQuery(this.pageNation.pageIndex)
  }
};
</script>

<style lang="scss">

.default_input_style{
  width: 100% !important;
}
.date_input_style{
  .el-input__inner{
    padding-left: 40px;
  }
}
.default_box_style{
  padding:0 24px;
  font-size:14px;
  color:#4E5969;
  overflow-y: auto;
  height: calc(100vh - 60px);
  padding-bottom: 65px;
  .default_title_style{
    padding-bottom: 8px;
    color:#4E5969;
  }
  .default_input_style{
    margin-bottom: 16px;
    font-size:14px;
  }
  .el-input-number {
    line-height: 31px;
    width: 100%;
    span {
      height: 30px;
    }
  }
  .el-date-editor{
    width: 100% !important;
  }
  .default-body-text {
    height: 20px;
    flex: none;
    color: #F53F3F;
  }
}
.default-body-image-list {
    display: flex;
    align-items: center;
    max-height: 200px;
    flex-wrap: wrap;
    margin-bottom: 16px;
  .default-body-image{
    height: 80px;
    width: 80px;
    border: 1px solid #C9CDD4;
    border-radius: 8px;
    margin-right: 16px;
    margin-top:8px;
    .default-body-image-icon{
      height: 72px;
      width: 72px;
      padding:4px;
      border-radius: 7px;
    }
  }
}
.default_box_style::-webkit-scrollbar {
  background-color: transparent;
  width: 8px;
}

.default_box_style::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.1);
  -webkit-box-shadow: #000;
}
.default-box::-webkit-scrollbar {
  background-color: transparent;
  width: 8px;

}

.default-box::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.1);
  -webkit-box-shadow: #000;
}

.el-overlay {
  z-index: 1998 !important;
}
.planHidden {
  display: none;
}
</style>

<style lang="scss" scoped>

:deep(.el-table__row) {
  td:last-child {
    .cell {
      overflow: hidden !important;
    }
  }
}

.picture-list {
  height: 500px;
  overflow-y: auto;

  .picture-list-item {
    cursor: pointer;
    display: inline-block;
    padding: 10px;
    max-width: 100%;
    box-sizing: border-box;
  }
}

.picture-list::-webkit-scrollbar {
  background-color: transparent;
  width: 8px;

}

.picture-list::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.1);
  -webkit-box-shadow: #000;
}

.blueColor {
  color: #165DFF;
}

.dangerColor {
  color: #F53F3F;
}

.successColor {
  color: #00C853;
}

.warningColor {
  color: #FF7D00;
}

.pointer {
  cursor: pointer;
}

.item_one {
  padding: 0 !important;
}

tbody {
  .is-left {
    .cell {
      text-align: left !important;
    }
  }
}

.is-cell {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.is-cell:hover {
  white-space: normal;
}

.planHidden {
  display: none;
}

.el-table__row {
  td:last-child {
    .cell {
      overflow: visible;
    }
  }
}

:deep(.el-drawer__header) {
  margin-bottom: 10px;
  padding: 0 24px;
  font-weight: 900;
  border-bottom: 1px solid #E5E6EB;
}

.titleDrawer {
  height: 50px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: 16px;
  color: #1D2129;
  font-weight: bold;
}

.default-body {
  display: flex;
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  padding: 0 10px;

  .default-body-left {
    width: 150px;
    flex: none;
    display: flex;
    flex-direction: column;
  }

  .default-body-item {
    display: flex;
    height: 50px;
    flex: none;
    align-items: center;
    font-size: 16px;
    color: #6a6a6a;

    :deep(.el-input--prefix) {
      width: 100% !important;
    }

    :deep(.el-input__icon) {
      line-height: 32px;
    }

    :deep(.el-input__inner) {
      padding-left: 34px;
    }

    :deep(.el-input-number) {
      line-height: 31px;
      width: 100%;

      span {
        height: 30px;
      }
    }

    :deep(.el-radio-group) {
      display: flex;
      justify-content: flex-start;

      .el-radio__input {
        display: flex;
        align-items: center;
      }

      .el-radio {
        font-size: 16px;
        display: flex;
        align-items: center;
        justify-content: flex-start;

        .el-radio__label {
          font-size: 16px;
        }
      }
    }

    .default-body-picture {
      display: flex;
      font-size: 12px;
      flex-direction: column;
      margin-left: 10px;
    }

  }

  .default-body-textarea {
    display: flex;
    min-height: 50px;
    align-items: center;
    color: #4E5969;
  }

  .default-body-title {
    display: flex;
    height: 100px;
    flex: none;
    align-items: center;
    justify-content: flex-start;
    font-size: 16px;
    color: #4E5969;
  }

  .default-body-image-list {
    display: flex;
    align-items: center;
    height: 100px;
    flex: none;
    overflow-y: auto;
    flex-direction: column;
    justify-content: center;

    .default-body-image {
      display: flex;
      align-items: center;
      cursor: pointer;
      color: #6a6a6a;
      width: 100%;

      .default-body-image-icon {
        width: 14px;
        height: 14px;
        flex: none;
        border-radius: 50%;
      }

      .default-body-image-name {
        width: 0;
        flex: 1;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        margin-left: 10px;
      }
    }
  }


  .default-body-image:hover {
    color: #165dff;
  }

  .default-body-text {
    height: 20px;
    flex: none;
    color: #F53F3F;
  }

  .default-body-right {
    flex: 1;
    display: flex;
    flex-direction: column;
  }
}
.myMultiple115 :deep(.el-select__tags) {
  padding-left: 115px;
  box-sizing: border-box;
}
.myMultiple95 :deep(.el-select__tags) {
  padding-left: 95px;
  box-sizing: border-box;
}
.myMultiple75 :deep(.el-select__tags) {
  padding-left: 75px;
  box-sizing: border-box;
}
</style>

<style lang="scss">
.haier-dialog--body{
      padding: 0 !important;
    }
  .info_table_style td {
         height:41px;
         font-size:14px;
         color:#666;
         border-bottom: 1px solid #ccc;
         border-right: 1px solid #ccc;
         text-align:center;
         background: #FAFAFA;
       
     }
     .info_table_body_style td {
       height:41px;
       font-size:14px;
       color:#666;
       border-bottom: 1px solid #ccc;
       border-right: 1px solid #ccc;
       text-align:center;
       white-space: nowrap;
       text-overflow: ellipsis;
       overflow: hidden;
       &:hover {
         white-space: normal;
         word-break: break-all;
       }
     }
     .tempUp_dialog_style{
       .haier-dialog{
         top:1% !important;
         .haier-table-header{
          display: none;
         }
      }
     }
.flow {
  height: 230px;
  overflow: auto;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;

  .flow-item {
    width: 1100px;
    border: 1px dashed #ccc;
    border-radius: 10px;
    height: 200px;
    margin: 10px 0;
    flex: none;

    .flow-item-title {
      height: 70px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 20px;
      font-weight: 900;
    }

    .flow-item-content {
      height: 100px;
      display: flex;
      align-content: center;
      justify-content: center;

      .flow-item-content-body {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: flex-start;

        .flow-item-content-body-item {
          width: 200px;
          height: 100%;
          background: #f3f3f3;
          margin: 0 10px;

          .flow-item-header {
            height: 50px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 16px;
          }

          .flow-item-time {
            display: flex;
            align-items: center;
            justify-content: center;
          }
        }
      }
    }
  }
}

.flow::-webkit-scrollbar {
  background-color: transparent;
  width: 8px;
}

.flow::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.1);
  -webkit-box-shadow: #000;
}

.flow-body {
  width: 100%;
  height: 95%;
  display: flex;
  align-items: flex-end;
  justify-content: center;
}
.flow-left {
  position: absolute;
  z-index: 1;
  width: 500px;
  height: 180px;
  overflow: hidden;
  line-height: 22px;
  left: 24px;
  div{
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  div:hover{
    overflow:auto;
    white-space: normal;
    text-overflow: unset;
  }
}
.grayBackColor{
  background: #f3f3f3 !important;
  color: black !important;
}
.blueBackColor{
  background: #165dff !important;
  color:#fff !important;
}
.tip_box{
  display: flex;
  align-items: center;
  .tip_icon_box{
    width: 24px;
    height: 24px;
    margin-left: 8px      ;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 6px;
    left: 0;
    color: #86909C;
    &:hover {
      background-color: #e0e2e8;
      color: #165DFF;
    }
  }
}
.history-table{
  margin: 16px 24px;
}
</style>